
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const ChatGptListingStatus = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  ARCHIVED: 'ARCHIVED'
} as const

export type ChatGptListingStatus = (typeof ChatGptListingStatus)[keyof typeof ChatGptListingStatus]


export const ChatGptMediaType = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  MODEL_3D: 'MODEL_3D'
} as const

export type ChatGptMediaType = (typeof ChatGptMediaType)[keyof typeof ChatGptMediaType]


export const ChatGptProductFieldType = {
  title: 'title',
  description: 'description',
  link: 'link',
  product_category: 'product_category',
  condition: 'condition',
  brand: 'brand',
  material: 'material',
  length: 'length',
  width: 'width',
  height: 'height',
  weight: 'weight',
  age_group: 'age_group'
} as const

export type ChatGptProductFieldType = (typeof ChatGptProductFieldType)[keyof typeof ChatGptProductFieldType]


export const ChatGptVariantFieldType = {
  sku: 'sku',
  price: 'price',
  sale_price: 'sale_price',
  sale_price_effective_date: 'sale_price_effective_date',
  unit_pricing_measure: 'unit_pricing_measure',
  base_measure: 'base_measure',
  pricing_trend: 'pricing_trend',
  color: 'color',
  size: 'size',
  size_system: 'size_system',
  gender: 'gender',
  offer_id: 'offer_id',
  custom_variant1_category: 'custom_variant1_category',
  custom_variant1_value: 'custom_variant1_value',
  custom_variant2_category: 'custom_variant2_category',
  custom_variant2_value: 'custom_variant2_value',
  custom_variant3_category: 'custom_variant3_category',
  custom_variant3_value: 'custom_variant3_value'
} as const

export type ChatGptVariantFieldType = (typeof ChatGptVariantFieldType)[keyof typeof ChatGptVariantFieldType]


export const BillingAutomation = {
  Auto: 'Auto',
  Manual: 'Manual'
} as const

export type BillingAutomation = (typeof BillingAutomation)[keyof typeof BillingAutomation]


export const BillingFailureMode = {
  Allow: 'Allow',
  Restrict: 'Restrict'
} as const

export type BillingFailureMode = (typeof BillingFailureMode)[keyof typeof BillingFailureMode]


export const BalanceTransactionType = {
  MarketplacePayout: 'MarketplacePayout',
  AcpPayment: 'AcpPayment'
} as const

export type BalanceTransactionType = (typeof BalanceTransactionType)[keyof typeof BalanceTransactionType]


export const BillType = {
  Shipping: 'Shipping',
  ReturnShipping: 'ReturnShipping',
  Software: 'Software'
} as const

export type BillType = (typeof BillType)[keyof typeof BillType]


export const BillStatus = {
  Open: 'Open',
  Closed: 'Closed',
  Paid: 'Paid',
  Void: 'Void',
  Failed: 'Failed',
  Refunded: 'Refunded',
  PartiallyRefunded: 'PartiallyRefunded'
} as const

export type BillStatus = (typeof BillStatus)[keyof typeof BillStatus]


export const BillingChargeType = {
  Coverage: 'Coverage',
  Return: 'Return',
  ShippingLabel: 'ShippingLabel',
  Subscription: 'Subscription',
  Campaign: 'Campaign',
  OrderTracking: 'OrderTracking',
  CheckoutOptimization: 'CheckoutOptimization',
  Recover: 'Recover',
  Credit: 'Credit',
  Usage: 'Usage'
} as const

export type BillingChargeType = (typeof BillingChargeType)[keyof typeof BillingChargeType]


export const BillingChargeSubtype = {
  ReturnCoverage: 'ReturnCoverage',
  PackageProtectionPlus: 'PackageProtectionPlus',
  PackageProtection: 'PackageProtection',
  FinalSaleReturnCoverage: 'FinalSaleReturnCoverage',
  ExtendedWarranty: 'ExtendedWarranty',
  UpsellRevenue: 'UpsellRevenue',
  UpsellRevenueRefunded: 'UpsellRevenueRefunded',
  ManagedClaimCredit: 'ManagedClaimCredit',
  RedoManagedReturnsCoverage: 'RedoManagedReturnsCoverage',
  InstantExchangeRecovery: 'InstantExchangeRecovery',
  InstantRefund: 'InstantRefund',
  RepairFeeCredit: 'RepairFeeCredit',
  CoverageRefundForCancelledOrder: 'CoverageRefundForCancelledOrder',
  CancelledOrderPackageProtectionPlusRefund: 'CancelledOrderPackageProtectionPlusRefund',
  DeniedClaimPackageProtectionPlusRefund: 'DeniedClaimPackageProtectionPlusRefund',
  CancelledOrderFinalSaleReturnCoverageRefund: 'CancelledOrderFinalSaleReturnCoverageRefund',
  CancelledOrderExtendedWarrantyRefund: 'CancelledOrderExtendedWarrantyRefund',
  CancelledOrderRmrProcessingCoverageShareRefund: 'CancelledOrderRmrProcessingCoverageShareRefund',
  CancelledOrderRmrConsolidationCoverageShareRefund: 'CancelledOrderRmrConsolidationCoverageShareRefund',
  CancelledOrderInstantExchangeRecovery: 'CancelledOrderInstantExchangeRecovery',
  FinalSaleCredit: 'FinalSaleCredit',
  CarrierClaimRefund: 'CarrierClaimRefund',
  claim_payout: 'claim_payout',
  claim_commission: 'claim_commission',
  ExchangeShippingCredit: 'ExchangeShippingCredit',
  PerOrder: 'PerOrder',
  PerSms: 'PerSms',
  PerEmail: 'PerEmail',
  OrderTracking: 'OrderTracking',
  MerchantCoveredLabel: 'MerchantCoveredLabel',
  Damaged: 'Damaged',
  WrongProduct: 'WrongProduct',
  MerchantCarrierLabelCredit: 'MerchantCarrierLabelCredit',
  ShippingCostShare: 'ShippingCostShare',
  ReturnLabelMarkupRevenue: 'ReturnLabelMarkupRevenue',
  CustomerPaidLabel: 'CustomerPaidLabel',
  PerReturnFee: 'PerReturnFee',
  ReturnsProcessingFee: 'ReturnsProcessingFee',
  ReturnFraudPrevention: 'ReturnFraudPrevention',
  PointOfSale: 'PointOfSale',
  PerRecycleRequestFee: 'PerRecycleRequestFee',
  ReFulfillmentRevenueShare: 'ReFulfillmentRevenueShare',
  ReFulfillmentShippingAdjustment: 'ReFulfillmentShippingAdjustment',
  PerExchangePayoutFee: 'PerExchangePayoutFee',
  MerchantCreatedReturnLabel: 'MerchantCreatedReturnLabel',
  PackagePickup: 'PackagePickup',
  CarrierPickup: 'CarrierPickup',
  CanceledReturnLabelRefund: 'CanceledReturnLabelRefund',
  CanceledPickupRefund: 'CanceledPickupRefund',
  OutboundLabel: 'OutboundLabel',
  ReturnLabelAdjustment: 'ReturnLabelAdjustment',
  ImplementationFee: 'ImplementationFee',
  CardProcessingFee: 'CardProcessingFee',
  ManualAdjustment: 'ManualAdjustment',
  ManualRefund: 'ManualRefund',
  VoidLabel: 'VoidLabel',
  VoidUsedLabel: 'VoidUsedLabel',
  ChargeLabel: 'ChargeLabel',
  Refund: 'Refund',
  Miscellaneous: 'Miscellaneous',
  Surcharge: 'Surcharge',
  ReturnLabel: 'ReturnLabel',
  MerchantCarrierFee: 'MerchantCarrierFee',
  SubscriptionFee: 'SubscriptionFee',
  RedeemPoints: 'RedeemPoints',
  Insurance: 'Insurance',
  VoidInsurance: 'VoidInsurance',
  TransactionFailureClawback: 'TransactionFailureClawback',
  WmsFee: 'WmsFee',
  RedoSupply: 'RedoSupply',
  LandedCostDuties: 'LandedCostDuties',
  LandedCostTaxes: 'LandedCostTaxes',
  LandedCostFees: 'LandedCostFees',
  VoidLandedCostDuties: 'VoidLandedCostDuties',
  VoidLandedCostTaxes: 'VoidLandedCostTaxes',
  VoidLandedCostFees: 'VoidLandedCostFees',
  FreightPurchase: 'FreightPurchase',
  VoidFreightPurchase: 'VoidFreightPurchase',
  ConsolidationShipping: 'ConsolidationShipping',
  RmrProcessingCoverageShare: 'RmrProcessingCoverageShare',
  RmrConsolidationCoverageShare: 'RmrConsolidationCoverageShare',
  FinalSaleCreditAdjustment: 'FinalSaleCreditAdjustment',
  free_trial_credit: 'free_trial_credit',
  merchant_incentive: 'merchant_incentive',
  zero_out_account_balance: 'zero_out_account_balance',
  cancelled_extended_warranty_refund: 'cancelled_extended_warranty_refund',
  cancelled_package_protection_plus_refund: 'cancelled_package_protection_plus_refund',
  cancelled_final_sale_return_coverage_refund: 'cancelled_final_sale_return_coverage_refund',
  cancelled_instant_exchange_recovery: 'cancelled_instant_exchange_recovery',
  merchant_paid_pp_plus_per_order: 'merchant_paid_pp_plus_per_order',
  coverage_adjustment: 'coverage_adjustment',
  non_coverage_adjustment: 'non_coverage_adjustment',
  pp_plus_adjustment: 'pp_plus_adjustment',
  fsr_adjustment: 'fsr_adjustment',
  rmr_adjustment: 'rmr_adjustment',
  oms_adjustment: 'oms_adjustment',
  other_adjustment: 'other_adjustment',
  claims_adjustment: 'claims_adjustment',
  chop_adjustment: 'chop_adjustment',
  order_tracking_adjustment: 'order_tracking_adjustment',
  shopper_ai_adjustment: 'shopper_ai_adjustment',
  subscription_adjustment: 'subscription_adjustment',
  warranties_adjustment: 'warranties_adjustment',
  marketing_adjustment: 'marketing_adjustment',
  duty_drawback_credit: 'duty_drawback_credit',
  reduce_balance: 'reduce_balance',
  promotional_credit: 'promotional_credit',
  usps_pc_postage_fee: 'usps_pc_postage_fee',
  writeoff: 'writeoff',
  personalized_insert_fee: 'personalized_insert_fee',
  personalized_insert_revenue_share: 'personalized_insert_revenue_share',
  rev_share_coverage: 'rev_share_coverage',
  final_sale_rev_share_coverage: 'final_sale_rev_share_coverage',
  pp_plus_rev_share_coverage: 'pp_plus_rev_share_coverage',
  package_protection_rev_share_coverage: 'package_protection_rev_share_coverage',
  cancelled_package_protection_refund: 'cancelled_package_protection_refund',
  cancelled_rev_share_coverage_refund: 'cancelled_rev_share_coverage_refund',
  cancelled_final_sale_rev_share_coverage_refund: 'cancelled_final_sale_rev_share_coverage_refund',
  cancelled_pp_plus_rev_share_coverage_refund: 'cancelled_pp_plus_rev_share_coverage_refund',
  cancelled_package_protection_rev_share_coverage_refund: 'cancelled_package_protection_rev_share_coverage_refund'
} as const

export type BillingChargeSubtype = (typeof BillingChargeSubtype)[keyof typeof BillingChargeSubtype]


export const SubscriptionProduct = {
  MarketingSms: 'MarketingSms',
  MarketingEmail: 'MarketingEmail',
  OrderTracking: 'OrderTracking',
  ReturnAiExchange: 'ReturnAiExchange',
  Returns: 'Returns',
  CheckoutOptimization: 'CheckoutOptimization',
  Aeo: 'Aeo',
  Ims: 'Ims',
  ImsForecasting: 'ImsForecasting',
  Recover: 'Recover',
  SupportBase: 'SupportBase',
  SupportAi: 'SupportAi',
  SupportSms: 'SupportSms',
  SupportVoice: 'SupportVoice',
  Oms: 'Oms',
  Wms: 'Wms',
  Disputes: 'Disputes',
  Lcg: 'Lcg',
  Ctx: 'Ctx'
} as const

export type SubscriptionProduct = (typeof SubscriptionProduct)[keyof typeof SubscriptionProduct]


export const CampaignChannel = {
  Sms: 'Sms',
  Mms: 'Mms',
  Email: 'Email'
} as const

export type CampaignChannel = (typeof CampaignChannel)[keyof typeof CampaignChannel]


export const TransactionStatus = {
  Pending: 'Pending',
  Success: 'Success',
  Failed: 'Failed'
} as const

export type TransactionStatus = (typeof TransactionStatus)[keyof typeof TransactionStatus]


export const BillingPeriod = {
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  Bimonthly: 'Bimonthly',
  Weekly: 'Weekly'
} as const

export type BillingPeriod = (typeof BillingPeriod)[keyof typeof BillingPeriod]


export const PaymentProvider = {
  Stripe: 'Stripe',
  Shopify: 'Shopify'
} as const

export type PaymentProvider = (typeof PaymentProvider)[keyof typeof PaymentProvider]


export const PaymentMethodType = {
  Card: 'Card',
  UsBankAccount: 'UsBankAccount',
  ShopifyAppSubscription: 'ShopifyAppSubscription'
} as const

export type PaymentMethodType = (typeof PaymentMethodType)[keyof typeof PaymentMethodType]


export const PaymentMethodPriority = {
  Primary: 'Primary',
  Secondary: 'Secondary',
  ShopifySubscription: 'ShopifySubscription',
  Deactivated: 'Deactivated'
} as const

export type PaymentMethodPriority = (typeof PaymentMethodPriority)[keyof typeof PaymentMethodPriority]


export const StripeAccountStatus = {
  Active: 'Active',
  Created: 'Created',
  Inactive: 'Inactive'
} as const

export type StripeAccountStatus = (typeof StripeAccountStatus)[keyof typeof StripeAccountStatus]


export const accounting_account_mapping_type_enum = {
  inventory_asset: 'inventory_asset',
  cogs: 'cogs',
  income: 'income',
  freight_expense: 'freight_expense',
  duty_expense: 'duty_expense',
  shrinkage: 'shrinkage',
  accounts_payable: 'accounts_payable',
  expense: 'expense',
  payment_account: 'payment_account'
} as const

export type accounting_account_mapping_type_enum = (typeof accounting_account_mapping_type_enum)[keyof typeof accounting_account_mapping_type_enum]


export const accounting_cost_method_enum = {
  fifo: 'fifo',
  weighted_average: 'weighted_average'
} as const

export type accounting_cost_method_enum = (typeof accounting_cost_method_enum)[keyof typeof accounting_cost_method_enum]


export const accounting_entity_type_enum = {
  purchase_order: 'purchase_order',
  supplier: 'supplier',
  adjustment_session: 'adjustment_session',
  shipment_receipt: 'shipment_receipt',
  fulfillment: 'fulfillment',
  return: 'return',
  product: 'product',
  transfer: 'transfer',
  transfer_order: 'transfer_order'
} as const

export type accounting_entity_type_enum = (typeof accounting_entity_type_enum)[keyof typeof accounting_entity_type_enum]


export const accounting_external_entity_type_enum = {
  bill: 'bill',
  vendor: 'vendor',
  journal_entry: 'journal_entry',
  purchase_order: 'purchase_order',
  item: 'item'
} as const

export type accounting_external_entity_type_enum = (typeof accounting_external_entity_type_enum)[keyof typeof accounting_external_entity_type_enum]


export const accounting_platform_enum = {
  quickbooks_online: 'quickbooks_online',
  xero: 'xero'
} as const

export type accounting_platform_enum = (typeof accounting_platform_enum)[keyof typeof accounting_platform_enum]


export const AeoRecommendationCategory = {
  competitor_insight: 'competitor_insight',
  content_opportunity: 'content_opportunity',
  earned_media_action: 'earned_media_action',
  product_improvement: 'product_improvement',
  winning_strategy: 'winning_strategy'
} as const

export type AeoRecommendationCategory = (typeof AeoRecommendationCategory)[keyof typeof AeoRecommendationCategory]


export const AeoRecommendationFeedbackKind = {
  positive: 'positive',
  negative: 'negative'
} as const

export type AeoRecommendationFeedbackKind = (typeof AeoRecommendationFeedbackKind)[keyof typeof AeoRecommendationFeedbackKind]


export const AeoRecommendationPriority = {
  high: 'high',
  medium: 'medium',
  low: 'low'
} as const

export type AeoRecommendationPriority = (typeof AeoRecommendationPriority)[keyof typeof AeoRecommendationPriority]


export const agent_change_kind = {
  create: 'create',
  update: 'update',
  delete: 'delete'
} as const

export type agent_change_kind = (typeof agent_change_kind)[keyof typeof agent_change_kind]


export const agent_entity_type = {
  product: 'product',
  supplier: 'supplier',
  bom: 'bom',
  purchase_order: 'purchase_order',
  location: 'location',
  adjustment_session: 'adjustment_session'
} as const

export type agent_entity_type = (typeof agent_entity_type)[keyof typeof agent_entity_type]


export const agent_knowledge_source = {
  MERCHANT_KNOWLEDGE: 'MERCHANT_KNOWLEDGE',
  FAQ: 'FAQ'
} as const

export type agent_knowledge_source = (typeof agent_knowledge_source)[keyof typeof agent_knowledge_source]


export const agent_knowledge_status = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  DISABLED: 'DISABLED'
} as const

export type agent_knowledge_status = (typeof agent_knowledge_status)[keyof typeof agent_knowledge_status]


export const agent_operation_type = {
  create_product: 'create_product',
  update_product: 'update_product',
  delete_product: 'delete_product',
  create_supplier: 'create_supplier',
  update_supplier: 'update_supplier',
  create_bom: 'create_bom',
  update_bom: 'update_bom',
  create_purchase_order: 'create_purchase_order',
  update_purchase_order: 'update_purchase_order',
  create_location: 'create_location',
  set_product_locations: 'set_product_locations',
  adjust_inventory: 'adjust_inventory'
} as const

export type agent_operation_type = (typeof agent_operation_type)[keyof typeof agent_operation_type]


export const ai_status = {
  ACTIVE: 'ACTIVE',
  HANDED_OFF: 'HANDED_OFF'
} as const

export type ai_status = (typeof ai_status)[keyof typeof ai_status]


export const amazon_feed_group_result_code = {
  success: 'success',
  error: 'error',
  warning: 'warning'
} as const

export type amazon_feed_group_result_code = (typeof amazon_feed_group_result_code)[keyof typeof amazon_feed_group_result_code]


export const amazon_feed_status = {
  submitted: 'submitted',
  done: 'done',
  failed: 'failed',
  cancelled: 'cancelled'
} as const

export type amazon_feed_status = (typeof amazon_feed_status)[keyof typeof amazon_feed_status]


export const attachment_type = {
  inline: 'inline',
  attachment: 'attachment'
} as const

export type attachment_type = (typeof attachment_type)[keyof typeof attachment_type]


export const attachment_visibility = {
  public: 'public',
  private: 'private'
} as const

export type attachment_visibility = (typeof attachment_visibility)[keyof typeof attachment_visibility]


export const attribution_cause_event_type = {
  email_send: 'email_send',
  email_delivered: 'email_delivered',
  email_open: 'email_open',
  email_click: 'email_click',
  sms_send: 'sms_send',
  sms_click: 'sms_click',
  recover_message_sent: 'recover_message_sent',
  recover_message_received: 'recover_message_received',
  recover_click: 'recover_click'
} as const

export type attribution_cause_event_type = (typeof attribution_cause_event_type)[keyof typeof attribution_cause_event_type]


export const attribution_comparison_operator = {
  gte: 'gte',
  lte: 'lte',
  eq: 'eq'
} as const

export type attribution_comparison_operator = (typeof attribution_comparison_operator)[keyof typeof attribution_comparison_operator]


export const attribution_effect_event_type = {
  order: 'order'
} as const

export type attribution_effect_event_type = (typeof attribution_effect_event_type)[keyof typeof attribution_effect_event_type]


export const attribution_model = {
  last_touch: 'last_touch',
  linear: 'linear',
  direct: 'direct'
} as const

export type attribution_model = (typeof attribution_model)[keyof typeof attribution_model]


export const attribution_time_unit = {
  minute: 'minute',
  hour: 'hour',
  day: 'day'
} as const

export type attribution_time_unit = (typeof attribution_time_unit)[keyof typeof attribution_time_unit]


export const attribution_touchpoint = {
  recover: 'recover',
  email: 'email',
  sms: 'sms'
} as const

export type attribution_touchpoint = (typeof attribution_touchpoint)[keyof typeof attribution_touchpoint]


export const bill_deferred_reason = {
  new_payment_method: 'new_payment_method',
  no_payment_method: 'no_payment_method'
} as const

export type bill_deferred_reason = (typeof bill_deferred_reason)[keyof typeof bill_deferred_reason]


export const bill_of_materials_product_kind = {
  input: 'input',
  output: 'output'
} as const

export type bill_of_materials_product_kind = (typeof bill_of_materials_product_kind)[keyof typeof bill_of_materials_product_kind]


export const bill_of_materials_status = {
  active: 'active',
  inactive: 'inactive',
  draft: 'draft'
} as const

export type bill_of_materials_status = (typeof bill_of_materials_status)[keyof typeof bill_of_materials_status]


export const billing_method = {
  standard: 'standard',
  shopify_collective: 'shopify_collective'
} as const

export type billing_method = (typeof billing_method)[keyof typeof billing_method]


export const breakdown_display_mode = {
  remove: 'remove',
  strikethrough: 'strikethrough'
} as const

export type breakdown_display_mode = (typeof breakdown_display_mode)[keyof typeof breakdown_display_mode]


export const bulk_pick_session_status = {
  in_progress: 'in_progress',
  completed: 'completed',
  cancelled: 'cancelled'
} as const

export type bulk_pick_session_status = (typeof bulk_pick_session_status)[keyof typeof bulk_pick_session_status]


export const channel_thread_participant_role = {
  primary_contact: 'primary_contact',
  participant: 'participant'
} as const

export type channel_thread_participant_role = (typeof channel_thread_participant_role)[keyof typeof channel_thread_participant_role]


export const channel_thread_participant_type = {
  shopper: 'shopper',
  merchant_user: 'merchant_user',
  redo_user: 'redo_user',
  agent: 'agent',
  system: 'system'
} as const

export type channel_thread_participant_type = (typeof channel_thread_participant_type)[keyof typeof channel_thread_participant_type]


export const chat_flow_input_step_type = {
  default: 'default',
  collect_email: 'collect_email',
  code_verification: 'code_verification',
  offering_convert_to_email: 'offering_convert_to_email'
} as const

export type chat_flow_input_step_type = (typeof chat_flow_input_step_type)[keyof typeof chat_flow_input_step_type]


export const commentsold_listing_status = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
} as const

export type commentsold_listing_status = (typeof commentsold_listing_status)[keyof typeof commentsold_listing_status]


export const compensation_phase = {
  approval: 'approval',
  in_transit: 'in_transit',
  delivered: 'delivered'
} as const

export type compensation_phase = (typeof compensation_phase)[keyof typeof compensation_phase]


export const consolidation_carton_status = {
  open: 'open',
  sealed: 'sealed',
  voided: 'voided'
} as const

export type consolidation_carton_status = (typeof consolidation_carton_status)[keyof typeof consolidation_carton_status]


export const consolidation_item_kind = {
  inventory_item: 'inventory_item',
  fulfillment_group_parcel: 'fulfillment_group_parcel'
} as const

export type consolidation_item_kind = (typeof consolidation_item_kind)[keyof typeof consolidation_item_kind]


export const consolidation_kind = {
  returns_transfer: 'returns_transfer',
  carrier_overbox: 'carrier_overbox',
  carrier_consolidation: 'carrier_consolidation'
} as const

export type consolidation_kind = (typeof consolidation_kind)[keyof typeof consolidation_kind]


export const consolidation_status = {
  open: 'open',
  closed: 'closed',
  sealed: 'sealed',
  completed: 'completed',
  cancelled: 'cancelled'
} as const

export type consolidation_status = (typeof consolidation_status)[keyof typeof consolidation_status]


export const conversation_product = {
  support: 'support',
  shopper_ai: 'shopper_ai',
  recover: 'recover',
  marketing: 'marketing'
} as const

export type conversation_product = (typeof conversation_product)[keyof typeof conversation_product]


export const country_provisioning_state = {
  provisioning: 'provisioning',
  active: 'active',
  deprovisioning: 'deprovisioning',
  deprovisioned: 'deprovisioned'
} as const

export type country_provisioning_state = (typeof country_provisioning_state)[keyof typeof country_provisioning_state]


export const currency = {
  AED: 'AED',
  AFN: 'AFN',
  ALL: 'ALL',
  AMD: 'AMD',
  ANG: 'ANG',
  AOA: 'AOA',
  ARS: 'ARS',
  AUD: 'AUD',
  AWG: 'AWG',
  AZN: 'AZN',
  BAM: 'BAM',
  BBD: 'BBD',
  BDT: 'BDT',
  BGN: 'BGN',
  BHD: 'BHD',
  BIF: 'BIF',
  BMD: 'BMD',
  BND: 'BND',
  BOB: 'BOB',
  BOV: 'BOV',
  BRL: 'BRL',
  BSD: 'BSD',
  BTN: 'BTN',
  BWP: 'BWP',
  BYN: 'BYN',
  BZD: 'BZD',
  CAD: 'CAD',
  CDF: 'CDF',
  CHF: 'CHF',
  CLP: 'CLP',
  CNY: 'CNY',
  COP: 'COP',
  CRC: 'CRC',
  CUC: 'CUC',
  CUP: 'CUP',
  CVE: 'CVE',
  CZK: 'CZK',
  DJF: 'DJF',
  DKK: 'DKK',
  DOP: 'DOP',
  DZD: 'DZD',
  EGP: 'EGP',
  ERN: 'ERN',
  ETB: 'ETB',
  EUR: 'EUR',
  FJD: 'FJD',
  FKP: 'FKP',
  GBP: 'GBP',
  GEL: 'GEL',
  GHS: 'GHS',
  GIP: 'GIP',
  GMD: 'GMD',
  GNF: 'GNF',
  GTQ: 'GTQ',
  GYD: 'GYD',
  HKD: 'HKD',
  HNL: 'HNL',
  HTG: 'HTG',
  HUF: 'HUF',
  IDR: 'IDR',
  ILS: 'ILS',
  INR: 'INR',
  IQD: 'IQD',
  IRR: 'IRR',
  ISK: 'ISK',
  JMD: 'JMD',
  JOD: 'JOD',
  JPY: 'JPY',
  KES: 'KES',
  KGS: 'KGS',
  KHR: 'KHR',
  KMF: 'KMF',
  KPW: 'KPW',
  KRW: 'KRW',
  KWD: 'KWD',
  KYD: 'KYD',
  KZT: 'KZT',
  LAK: 'LAK',
  LBP: 'LBP',
  LKR: 'LKR',
  LRD: 'LRD',
  LSL: 'LSL',
  LYD: 'LYD',
  MAD: 'MAD',
  MDL: 'MDL',
  MGA: 'MGA',
  MKD: 'MKD',
  MMK: 'MMK',
  MNT: 'MNT',
  MOP: 'MOP',
  MRU: 'MRU',
  MUR: 'MUR',
  MVR: 'MVR',
  MWK: 'MWK',
  MXN: 'MXN',
  MYR: 'MYR',
  MZN: 'MZN',
  NAD: 'NAD',
  NGN: 'NGN',
  NIO: 'NIO',
  NOK: 'NOK',
  NPR: 'NPR',
  NZD: 'NZD',
  OMR: 'OMR',
  PAB: 'PAB',
  PEN: 'PEN',
  PGK: 'PGK',
  PHP: 'PHP',
  PKR: 'PKR',
  PLN: 'PLN',
  PYG: 'PYG',
  QAR: 'QAR',
  RON: 'RON',
  RSD: 'RSD',
  RUB: 'RUB',
  RWF: 'RWF',
  SAR: 'SAR',
  SBD: 'SBD',
  SCR: 'SCR',
  SDG: 'SDG',
  SEK: 'SEK',
  SGD: 'SGD',
  SHP: 'SHP',
  SLE: 'SLE',
  SOS: 'SOS',
  SRD: 'SRD',
  SSP: 'SSP',
  STN: 'STN',
  SVC: 'SVC',
  SYP: 'SYP',
  SZL: 'SZL',
  THB: 'THB',
  TJS: 'TJS',
  TMT: 'TMT',
  TND: 'TND',
  TOP: 'TOP',
  TRY: 'TRY',
  TTD: 'TTD',
  TWD: 'TWD',
  TZS: 'TZS',
  UAH: 'UAH',
  UGX: 'UGX',
  USD: 'USD',
  UYU: 'UYU',
  UYW: 'UYW',
  UZS: 'UZS',
  VED: 'VED',
  VES: 'VES',
  VND: 'VND',
  VUV: 'VUV',
  WST: 'WST',
  XAF: 'XAF',
  XAG: 'XAG',
  XAU: 'XAU',
  XBA: 'XBA',
  XBB: 'XBB',
  XBC: 'XBC',
  XBD: 'XBD',
  XCD: 'XCD',
  XDR: 'XDR',
  XOF: 'XOF',
  XPD: 'XPD',
  XPF: 'XPF',
  XPT: 'XPT',
  XSU: 'XSU',
  XTS: 'XTS',
  XUA: 'XUA',
  XXX: 'XXX',
  YER: 'YER',
  ZAR: 'ZAR',
  ZMW: 'ZMW',
  ZWG: 'ZWG',
  ZWL: 'ZWL',
  BYR: 'BYR',
  HRK: 'HRK',
  JEP: 'JEP',
  KID: 'KID',
  LTL: 'LTL',
  LVL: 'LVL',
  SLL: 'SLL',
  STD: 'STD',
  USDC: 'USDC',
  VEF: 'VEF'
} as const

export type currency = (typeof currency)[keyof typeof currency]


export const customer_custom_field_data_type = {
  string: 'string',
  number: 'number',
  boolean: 'boolean',
  date: 'date'
} as const

export type customer_custom_field_data_type = (typeof customer_custom_field_data_type)[keyof typeof customer_custom_field_data_type]


export const customer_origin = {
  email: 'email',
  redoChat: 'redoChat',
  shopify: 'shopify',
  instagram: 'instagram',
  facebook: 'facebook',
  instagramComments: 'instagramComments',
  facebookComments: 'facebookComments',
  redo: 'redo',
  attentive: 'attentive',
  postscript: 'postscript',
  warranty: 'warranty',
  klaviyo: 'klaviyo',
  tiktok: 'tiktok',
  import: 'import',
  unknown: 'unknown'
} as const

export type customer_origin = (typeof customer_origin)[keyof typeof customer_origin]


export const customer_tag_provider = {
  redo: 'redo',
  commentsold: 'commentsold',
  shopify: 'shopify'
} as const

export type customer_tag_provider = (typeof customer_tag_provider)[keyof typeof customer_tag_provider]


export const customer_tag_source = {
  redo_support: 'redo_support',
  shopify: 'shopify',
  redo_marketing: 'redo_marketing'
} as const

export type customer_tag_source = (typeof customer_tag_source)[keyof typeof customer_tag_source]


export const cycle_count_rule_status = {
  live: 'live',
  disabled: 'disabled',
  draft: 'draft'
} as const

export type cycle_count_rule_status = (typeof cycle_count_rule_status)[keyof typeof cycle_count_rule_status]


export const cycle_count_rule_type = {
  abc: 'abc',
  custom: 'custom',
  random: 'random',
  exception: 'exception'
} as const

export type cycle_count_rule_type = (typeof cycle_count_rule_type)[keyof typeof cycle_count_rule_type]


export const cycle_count_source = {
  auto: 'auto',
  manual: 'manual'
} as const

export type cycle_count_source = (typeof cycle_count_source)[keyof typeof cycle_count_source]


export const cycle_count_status = {
  todo: 'todo',
  in_progress: 'in_progress',
  needs_review: 'needs_review',
  completed: 'completed',
  cancelled: 'cancelled'
} as const

export type cycle_count_status = (typeof cycle_count_status)[keyof typeof cycle_count_status]


export const day_of_week = {
  sunday: 'sunday',
  monday: 'monday',
  tuesday: 'tuesday',
  wednesday: 'wednesday',
  thursday: 'thursday',
  friday: 'friday',
  saturday: 'saturday'
} as const

export type day_of_week = (typeof day_of_week)[keyof typeof day_of_week]


export const DimensionUnit = {
  mm: 'mm',
  cm: 'cm',
  m: 'm',
  in: 'in',
  ft: 'ft',
  yd: 'yd'
} as const

export type DimensionUnit = (typeof DimensionUnit)[keyof typeof DimensionUnit]


export const dispute_alert_decision = {
  auto_resolved: 'auto_resolved',
  manual_review: 'manual_review'
} as const

export type dispute_alert_decision = (typeof dispute_alert_decision)[keyof typeof dispute_alert_decision]


export const dispute_alert_status = {
  needs_review: 'needs_review',
  resolved: 'resolved',
  cancelled: 'cancelled'
} as const

export type dispute_alert_status = (typeof dispute_alert_status)[keyof typeof dispute_alert_status]


export const dispute_alert_type = {
  rdr: 'rdr',
  cdrn: 'cdrn',
  ethoca: 'ethoca'
} as const

export type dispute_alert_type = (typeof dispute_alert_type)[keyof typeof dispute_alert_type]


export const dispute_evidence_source = {
  redo: 'redo',
  disputely: 'disputely'
} as const

export type dispute_evidence_source = (typeof dispute_evidence_source)[keyof typeof dispute_evidence_source]


export const dispute_source = {
  shopify: 'shopify',
  paypal: 'paypal'
} as const

export type dispute_source = (typeof dispute_source)[keyof typeof dispute_source]


export const dispute_status = {
  needs_response: 'needs_response',
  under_review: 'under_review',
  charge_refunded: 'charge_refunded',
  accepted: 'accepted',
  won: 'won',
  lost: 'lost',
  prevented: 'prevented'
} as const

export type dispute_status = (typeof dispute_status)[keyof typeof dispute_status]


export const dispute_type = {
  chargeback: 'chargeback',
  inquiry: 'inquiry'
} as const

export type dispute_type = (typeof dispute_type)[keyof typeof dispute_type]


export const dkim_status = {
  pending: 'pending',
  verified: 'verified',
  failed: 'failed',
  not_started: 'not_started'
} as const

export type dkim_status = (typeof dkim_status)[keyof typeof dkim_status]


export const dns_record_check_status = {
  ok: 'ok',
  missing: 'missing',
  misconfigured: 'misconfigured',
  error: 'error',
  not_applicable: 'not_applicable'
} as const

export type dns_record_check_status = (typeof dns_record_check_status)[keyof typeof dns_record_check_status]


export const dns_record_kind = {
  dkim: 'dkim',
  spf: 'spf',
  dmarc: 'dmarc',
  mail_from_mx: 'mail_from_mx',
  mail_from_spf: 'mail_from_spf'
} as const

export type dns_record_kind = (typeof dns_record_kind)[keyof typeof dns_record_kind]


export const download_category = {
  system: 'system'
} as const

export type download_category = (typeof download_category)[keyof typeof download_category]


export const download_cloud = {
  marketing: 'marketing'
} as const

export type download_cloud = (typeof download_cloud)[keyof typeof download_cloud]


export const download_format = {
  csv: 'csv',
  json: 'json',
  ndjson: 'ndjson'
} as const

export type download_format = (typeof download_format)[keyof typeof download_format]


export const download_status = {
  pending: 'pending',
  processing: 'processing',
  completed: 'completed',
  failed: 'failed',
  cancelled: 'cancelled',
  expired: 'expired'
} as const

export type download_status = (typeof download_status)[keyof typeof download_status]


export const draft_message_candidate_state = {
  visible: 'visible',
  accepted: 'accepted',
  declined: 'declined',
  superseded: 'superseded'
} as const

export type draft_message_candidate_state = (typeof draft_message_candidate_state)[keyof typeof draft_message_candidate_state]


export const draft_message_kind = {
  merchant: 'merchant',
  ai_copilot: 'ai_copilot',
  autopilot_send: 'autopilot_send'
} as const

export type draft_message_kind = (typeof draft_message_kind)[keyof typeof draft_message_kind]


export const draft_message_status = {
  PENDING: 'PENDING',
  SENDING: 'SENDING',
  ERROR: 'ERROR',
  DELETED: 'DELETED'
} as const

export type draft_message_status = (typeof draft_message_status)[keyof typeof draft_message_status]


export const ecommerce_platform = {
  shopify: 'shopify',
  commerceCloud: 'commerceCloud',
  commentsold: 'commentsold',
  bigcommerce: 'bigcommerce'
} as const

export type ecommerce_platform = (typeof ecommerce_platform)[keyof typeof ecommerce_platform]


export const email_correction_status = {
  pending: 'pending',
  approved: 'approved',
  dismissed: 'dismissed'
} as const

export type email_correction_status = (typeof email_correction_status)[keyof typeof email_correction_status]


export const external_return_hub_type = {
  returnbear: 'returnbear',
  blueyonder: 'blueyonder',
  shipmonk: 'shipmonk',
  ryder: 'ryder',
  deposco: 'deposco',
  netsuite: 'netsuite',
  mintsoft: 'mintsoft'
} as const

export type external_return_hub_type = (typeof external_return_hub_type)[keyof typeof external_return_hub_type]


export const geo_jsontype = {
  Point: 'Point'
} as const

export type geo_jsontype = (typeof geo_jsontype)[keyof typeof geo_jsontype]


export const grade_acceptance = {
  accept: 'accept',
  reject: 'reject',
  flag_for_review: 'flag_for_review'
} as const

export type grade_acceptance = (typeof grade_acceptance)[keyof typeof grade_acceptance]


export const hs_coherence_outcome = {
  coherent: 'coherent',
  somewhat_coherent: 'somewhat_coherent',
  not_coherent: 'not_coherent',
  valid: 'valid',
  invalid: 'invalid',
  not_applicable: 'not_applicable'
} as const

export type hs_coherence_outcome = (typeof hs_coherence_outcome)[keyof typeof hs_coherence_outcome]


export const hsa_answer_session_status = {
  in_progress: 'in_progress',
  completed: 'completed',
  abandoned: 'abandoned'
} as const

export type hsa_answer_session_status = (typeof hsa_answer_session_status)[keyof typeof hsa_answer_session_status]


export const hsa_eligibility = {
  not_eligible: 'not_eligible',
  eligible: 'eligible',
  eligible_with_lmn: 'eligible_with_lmn'
} as const

export type hsa_eligibility = (typeof hsa_eligibility)[keyof typeof hsa_eligibility]


export const hsa_questionnaire_flow_event_kind = {
  created: 'created',
  set_active: 'set_active'
} as const

export type hsa_questionnaire_flow_event_kind = (typeof hsa_questionnaire_flow_event_kind)[keyof typeof hsa_questionnaire_flow_event_kind]


export const ims_status = {
  read_only: 'read_only',
  pending: 'pending',
  source_of_truth: 'source_of_truth'
} as const

export type ims_status = (typeof ims_status)[keyof typeof ims_status]


export const inbound_shipment_status = {
  PENDING: 'PENDING',
  IN_TRANSIT: 'IN_TRANSIT',
  PARTIALLY_RECEIVED: 'PARTIALLY_RECEIVED',
  RECEIVED: 'RECEIVED'
} as const

export type inbound_shipment_status = (typeof inbound_shipment_status)[keyof typeof inbound_shipment_status]


export const integration_source = {
  redo: 'redo',
  malomo: 'malomo'
} as const

export type integration_source = (typeof integration_source)[keyof typeof integration_source]


export const inventory_adjustment_reason_direction = {
  positive: 'positive',
  negative: 'negative'
} as const

export type inventory_adjustment_reason_direction = (typeof inventory_adjustment_reason_direction)[keyof typeof inventory_adjustment_reason_direction]


export const inventory_item_class = {
  lot: 'lot',
  custom: 'custom'
} as const

export type inventory_item_class = (typeof inventory_item_class)[keyof typeof inventory_item_class]


export const inventory_level_adjustment_kind = {
  manual: 'manual',
  pick: 'pick',
  putaway: 'putaway',
  receiving: 'receiving',
  transfer: 'transfer',
  replenish: 'replenish',
  bin_count: 'bin_count',
  cycle_count: 'cycle_count',
  return_restock: 'return_restock',
  fulfillment_created: 'fulfillment_created',
  fulfillment_cancelled: 'fulfillment_cancelled',
  purchase_order_received: 'purchase_order_received',
  fulfillment_order_created: 'fulfillment_order_created',
  fulfillment_order_cancelled: 'fulfillment_order_cancelled',
  fulfillment_order_edited: 'fulfillment_order_edited',
  sot_initialization: 'sot_initialization',
  unknown: 'unknown',
  manual_pick: 'manual_pick',
  void_label: 'void_label',
  work_order: 'work_order',
  flush: 'flush',
  conversion: 'conversion',
  supplies: 'supplies'
} as const

export type inventory_level_adjustment_kind = (typeof inventory_level_adjustment_kind)[keyof typeof inventory_level_adjustment_kind]


export const landed_cost_item = {
  duties: 'duties',
  taxes: 'taxes',
  fees: 'fees'
} as const

export type landed_cost_item = (typeof landed_cost_item)[keyof typeof landed_cost_item]


export const lane_source = {
  detected: 'detected',
  confirmed: 'confirmed'
} as const

export type lane_source = (typeof lane_source)[keyof typeof lane_source]


export const lane_use = {
  returns: 'returns'
} as const

export type lane_use = (typeof lane_use)[keyof typeof lane_use]


export const ListingOptimizationJobStatus = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  ERROR: 'ERROR',
  COMPLETE: 'COMPLETE'
} as const

export type ListingOptimizationJobStatus = (typeof ListingOptimizationJobStatus)[keyof typeof ListingOptimizationJobStatus]


export const ListingType = {
  general: 'general',
  shopify: 'shopify',
  chatgpt: 'chatgpt',
  amazon: 'amazon',
  walmart: 'walmart',
  perplexity: 'perplexity',
  redo_marketplace: 'redo_marketplace',
  ebay: 'ebay',
  google_shopping: 'google_shopping'
} as const

export type ListingType = (typeof ListingType)[keyof typeof ListingType]


export const location_source = {
  warranty_registration: 'warranty_registration',
  billing_address: 'billing_address',
  ip_address: 'ip_address',
  api: 'api'
} as const

export type location_source = (typeof location_source)[keyof typeof location_source]


export const loyalty_earning_rule_type = {
  purchase: 'purchase',
  accountCreation: 'accountCreation',
  instagram: 'instagram',
  facebook: 'facebook',
  tiktok: 'tiktok',
  birthday: 'birthday',
  review: 'review'
} as const

export type loyalty_earning_rule_type = (typeof loyalty_earning_rule_type)[keyof typeof loyalty_earning_rule_type]


export const loyalty_lion_insights_segment = {
  At_Risk: 'At_Risk',
  Win_Back: 'Win_Back',
  Loyal: 'Loyal'
} as const

export type loyalty_lion_insights_segment = (typeof loyalty_lion_insights_segment)[keyof typeof loyalty_lion_insights_segment]


export const mail_from_domain_status = {
  pending: 'pending',
  success: 'success',
  failed: 'failed',
  not_started: 'not_started'
} as const

export type mail_from_domain_status = (typeof mail_from_domain_status)[keyof typeof mail_from_domain_status]


export const market_source = {
  shopify: 'shopify'
} as const

export type market_source = (typeof market_source)[keyof typeof market_source]


export const marketing_consent_status = {
  not_subscribed: 'not_subscribed',
  subscribed: 'subscribed',
  confirmed: 'confirmed',
  unsubscribed: 'unsubscribed'
} as const

export type marketing_consent_status = (typeof marketing_consent_status)[keyof typeof marketing_consent_status]


export const marketing_entry_point = {
  form: 'form',
  shopify: 'shopify',
  backfill: 'backfill',
  commentsold: 'commentsold',
  save_for_later: 'save_for_later',
  login: 'login',
  order_tracking: 'order_tracking',
  import: 'import',
  unknown: 'unknown',
  merchant: 'merchant',
  warranty_registration: 'warranty_registration',
  meta_lead_ads: 'meta_lead_ads',
  postscript: 'postscript',
  order_tracking_page: 'order_tracking_page',
  text_to_subscribe: 'text_to_subscribe',
  text_keyword_to_subscribe: 'text_keyword_to_subscribe',
  public_api: 'public_api',
  alia: 'alia',
  klaviyo_sync: 'klaviyo_sync'
} as const

export type marketing_entry_point = (typeof marketing_entry_point)[keyof typeof marketing_entry_point]


export const marketing_subscribe_keyword_status = {
  active: 'active',
  inactive: 'inactive'
} as const

export type marketing_subscribe_keyword_status = (typeof marketing_subscribe_keyword_status)[keyof typeof marketing_subscribe_keyword_status]


export const markup_strategy = {
  absorbing: 'absorbing',
  additive: 'additive'
} as const

export type markup_strategy = (typeof markup_strategy)[keyof typeof markup_strategy]


export const merchant_knowledge_origin = {
  MERCHANT: 'MERCHANT',
  AI_SUGGESTED: 'AI_SUGGESTED',
  SCRAPED: 'SCRAPED',
  IMPORTED: 'IMPORTED'
} as const

export type merchant_knowledge_origin = (typeof merchant_knowledge_origin)[keyof typeof merchant_knowledge_origin]


export const merchant_knowledge_suggestion_status = {
  ACCEPTED: 'ACCEPTED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED'
} as const

export type merchant_knowledge_suggestion_status = (typeof merchant_knowledge_suggestion_status)[keyof typeof merchant_knowledge_suggestion_status]


export const merchant_submission_status = {
  submitted: 'submitted',
  contacted: 'contacted',
  closed: 'closed'
} as const

export type merchant_submission_status = (typeof merchant_submission_status)[keyof typeof merchant_submission_status]


export const message_content_type = {
  text: 'text',
  toolConfirmationPrompt: 'toolConfirmationPrompt',
  uiComponent: 'uiComponent'
} as const

export type message_content_type = (typeof message_content_type)[keyof typeof message_content_type]


export const message_facebook_comment_attribute = {
  has_been_replied_to: 'has_been_replied_to',
  liked: 'liked'
} as const

export type message_facebook_comment_attribute = (typeof message_facebook_comment_attribute)[keyof typeof message_facebook_comment_attribute]


export const message_facebook_comment_state = {
  normal: 'normal',
  deleted: 'deleted',
  hidden: 'hidden',
  edited: 'edited'
} as const

export type message_facebook_comment_state = (typeof message_facebook_comment_state)[keyof typeof message_facebook_comment_state]


export const message_processing_status = {
  pending: 'pending',
  processing: 'processing',
  processed: 'processed',
  failed: 'failed'
} as const

export type message_processing_status = (typeof message_processing_status)[keyof typeof message_processing_status]


export const message_sender_type = {
  merchant: 'merchant',
  customer: 'customer',
  system: 'system',
  ai: 'ai',
  auto_reply: 'auto_reply',
  chat_flow: 'chat_flow'
} as const

export type message_sender_type = (typeof message_sender_type)[keyof typeof message_sender_type]


export const message_topic_link_source = {
  continuation_policy: 'continuation_policy',
  reply_action: 'reply_action',
  manual: 'manual',
  migration: 'migration',
  handoff: 'handoff'
} as const

export type message_topic_link_source = (typeof message_topic_link_source)[keyof typeof message_topic_link_source]


export const notification_kind = {
  return_created: 'return_created',
  return_delivered: 'return_delivered',
  return_review: 'return_review',
  claim_created: 'claim_created',
  claim_delivered: 'claim_delivered',
  claim_review: 'claim_review',
  warranty_created: 'warranty_created',
  warranty_delivered: 'warranty_delivered',
  warranty_review: 'warranty_review',
  order_tracking_stalled: 'order_tracking_stalled',
  order_tracking_delayed: 'order_tracking_delayed',
  order_tracking_return_to_sender: 'order_tracking_return_to_sender',
  order_tracking_delivery_attempt: 'order_tracking_delivery_attempt',
  order_tracking_delivery_failed: 'order_tracking_delivery_failed',
  order_tracking_delivery_cancelled: 'order_tracking_delivery_cancelled',
  order_tracking_delivery_error: 'order_tracking_delivery_error',
  outbound_labels_funds_low: 'outbound_labels_funds_low',
  outbound_labels_claim_processed: 'outbound_labels_claim_processed',
  outbound_labels_surcharge_dispute_update: 'outbound_labels_surcharge_dispute_update',
  inventory_low_stock: 'inventory_low_stock',
  support: 'support',
  task: 'task',
  report: 'report',
  billing: 'billing',
  admin: 'admin'
} as const

export type notification_kind = (typeof notification_kind)[keyof typeof notification_kind]


export const notification_source = {
  returns: 'returns',
  order_tracking: 'order_tracking',
  outbound_labels: 'outbound_labels',
  inventory: 'inventory',
  support: 'support',
  system: 'system'
} as const

export type notification_source = (typeof notification_source)[keyof typeof notification_source]


export const notification_subscription_status = {
  default: 'default',
  subscribed: 'subscribed',
  unsubscribed: 'unsubscribed'
} as const

export type notification_subscription_status = (typeof notification_subscription_status)[keyof typeof notification_subscription_status]


export const onboarding_knowledge_entry_category = {
  industry_playbook: 'industry_playbook',
  edge_case: 'edge_case',
  objection_handling: 'objection_handling',
  integration_guide: 'integration_guide',
  product_category: 'product_category',
  regional_compliance: 'regional_compliance',
  conversation_pattern: 'conversation_pattern',
  seasonal_playbook: 'seasonal_playbook',
  stakeholder_navigation: 'stakeholder_navigation'
} as const

export type onboarding_knowledge_entry_category = (typeof onboarding_knowledge_entry_category)[keyof typeof onboarding_knowledge_entry_category]


export const onboarding_knowledge_entry_source = {
  pipeline: 'pipeline',
  static_pack: 'static_pack',
  manual: 'manual',
  live_gap: 'live_gap',
  gap_conversion: 'gap_conversion'
} as const

export type onboarding_knowledge_entry_source = (typeof onboarding_knowledge_entry_source)[keyof typeof onboarding_knowledge_entry_source]


export const onboarding_knowledge_entry_status = {
  draft: 'draft',
  active: 'active',
  deprecated: 'deprecated'
} as const

export type onboarding_knowledge_entry_status = (typeof onboarding_knowledge_entry_status)[keyof typeof onboarding_knowledge_entry_status]


export const onboarding_product = {
  returns: 'returns',
  package_protection: 'package_protection',
  warranties: 'warranties',
  oms: 'oms',
  email_sms: 'email_sms',
  conversion: 'conversion',
  support_ai: 'support_ai',
  ims: 'ims',
  aeo: 'aeo',
  catalog: 'catalog',
  order_tracking: 'order_tracking',
  order_editing: 'order_editing',
  recover: 'recover'
} as const

export type onboarding_product = (typeof onboarding_product)[keyof typeof onboarding_product]


export const order_transaction_kind = {
  authorization: 'authorization',
  capture: 'capture',
  sale: 'sale',
  void: 'void',
  refund: 'refund'
} as const

export type order_transaction_kind = (typeof order_transaction_kind)[keyof typeof order_transaction_kind]


export const order_transaction_status = {
  pending: 'pending',
  success: 'success',
  failure: 'failure',
  error: 'error'
} as const

export type order_transaction_status = (typeof order_transaction_status)[keyof typeof order_transaction_status]


export const packing_mode = {
  individual: 'individual',
  case_pack: 'case_pack',
  pallet: 'pallet',
  weight: 'weight'
} as const

export type packing_mode = (typeof packing_mode)[keyof typeof packing_mode]


export const packing_template_type = {
  case_pack: 'case_pack',
  pallet: 'pallet'
} as const

export type packing_template_type = (typeof packing_template_type)[keyof typeof packing_template_type]


export const partner_account_status = {
  active: 'active',
  paused: 'paused',
  terminated: 'terminated'
} as const

export type partner_account_status = (typeof partner_account_status)[keyof typeof partner_account_status]


export const partner_account_type = {
  individual: 'individual',
  app: 'app',
  agency: 'agency'
} as const

export type partner_account_type = (typeof partner_account_type)[keyof typeof partner_account_type]


export const partner_auth_event_type = {
  magic_link_sent: 'magic_link_sent',
  magic_link_verified: 'magic_link_verified',
  magic_link_invalid: 'magic_link_invalid',
  magic_link_expired: 'magic_link_expired',
  magic_link_already_used: 'magic_link_already_used',
  login_success: 'login_success',
  login_failure: 'login_failure',
  logout: 'logout',
  session_refreshed: 'session_refreshed',
  admin_impersonation_exchange: 'admin_impersonation_exchange'
} as const

export type partner_auth_event_type = (typeof partner_auth_event_type)[keyof typeof partner_auth_event_type]


export const partner_payout_status = {
  pending: 'pending',
  paid: 'paid',
  failed: 'failed'
} as const

export type partner_payout_status = (typeof partner_payout_status)[keyof typeof partner_payout_status]


export const partner_product = {
  chargebacks: 'chargebacks'
} as const

export type partner_product = (typeof partner_product)[keyof typeof partner_product]


export const pill_theme = {
  NORMAL: 'NORMAL',
  PRIMARY_LIGHT: 'PRIMARY_LIGHT',
  LIGHT_PINK: 'LIGHT_PINK',
  DANGER: 'DANGER',
  NEUTRAL_YELLOW: 'NEUTRAL_YELLOW',
  SUCCESS: 'SUCCESS',
  NEUTRAL_BLUE: 'NEUTRAL_BLUE',
  PRIMARY: 'PRIMARY',
  SOLID_WHITE: 'SOLID_WHITE',
  SOLID_PINK: 'SOLID_PINK',
  SOLID_RED: 'SOLID_RED',
  SOLID_ORANGE: 'SOLID_ORANGE',
  SOLID_YELLOW: 'SOLID_YELLOW',
  SOLID_GREEN: 'SOLID_GREEN',
  SOLID_LIGHT_BLUE: 'SOLID_LIGHT_BLUE',
  SOLID_NAVY: 'SOLID_NAVY',
  SOLID_BLACK: 'SOLID_BLACK',
  BRAND: 'BRAND',
  GRAY_BLUE: 'GRAY_BLUE',
  WHITE_SUCCESS: 'WHITE_SUCCESS',
  GRAY_ALTERNATE: 'GRAY_ALTERNATE',
  BRAND_ALTERNATE: 'BRAND_ALTERNATE',
  ERROR_ALTERNATE: 'ERROR_ALTERNATE',
  WARNING_ALTERNATE: 'WARNING_ALTERNATE',
  SUCCESS_ALTERNATE: 'SUCCESS_ALTERNATE',
  GRAY_BLUE_ALTERNATE: 'GRAY_BLUE_ALTERNATE',
  BLUE_LIGHT_ALTERNATE: 'BLUE_LIGHT_ALTERNATE',
  BLUE_ALTERNATE: 'BLUE_ALTERNATE',
  INDIGO_ALTERNATE: 'INDIGO_ALTERNATE',
  PURPLE_ALTERNATE: 'PURPLE_ALTERNATE',
  PINK_ALTERNATE: 'PINK_ALTERNATE',
  ORANGE_ALTERNATE: 'ORANGE_ALTERNATE',
  BLACK_ALTERNATE: 'BLACK_ALTERNATE',
  WHITE_ALTERNATE: 'WHITE_ALTERNATE',
  WHITE_SUCCESS_ALTERNATE: 'WHITE_SUCCESS_ALTERNATE'
} as const

export type pill_theme = (typeof pill_theme)[keyof typeof pill_theme]


export const po_email_frequency = {
  daily: 'daily',
  weekly: 'weekly',
  bi_weekly: 'bi_weekly',
  monthly: 'monthly'
} as const

export type po_email_frequency = (typeof po_email_frequency)[keyof typeof po_email_frequency]


export const po_upload_job_file_status = {
  PENDING: 'PENDING',
  EXTRACTING: 'EXTRACTING',
  MATCHING: 'MATCHING',
  CREATING_PO: 'CREATING_PO',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED'
} as const

export type po_upload_job_file_status = (typeof po_upload_job_file_status)[keyof typeof po_upload_job_file_status]


export const po_upload_job_status = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED'
} as const

export type po_upload_job_status = (typeof po_upload_job_status)[keyof typeof po_upload_job_status]


export const price_book_status = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  ARCHIVED: 'ARCHIVED'
} as const

export type price_book_status = (typeof price_book_status)[keyof typeof price_book_status]


export const processing_fee_basis = {
  per_return: 'per_return',
  per_item: 'per_item'
} as const

export type processing_fee_basis = (typeof processing_fee_basis)[keyof typeof processing_fee_basis]


export const processing_level = {
  receiving: 'receiving',
  verification: 'verification',
  grading: 'grading'
} as const

export type processing_level = (typeof processing_level)[keyof typeof processing_level]


export const ProductFamilyKind = {
  SELLABLE: 'SELLABLE',
  NON_SELLABLE: 'NON_SELLABLE'
} as const

export type ProductFamilyKind = (typeof ProductFamilyKind)[keyof typeof ProductFamilyKind]


export const ProductInventoryPolicy = {
  CONTINUE: 'CONTINUE',
  DENY: 'DENY'
} as const

export type ProductInventoryPolicy = (typeof ProductInventoryPolicy)[keyof typeof ProductInventoryPolicy]


export const product_metric_type = {
  sold_7: 'sold_7',
  sold_14: 'sold_14',
  sold_21: 'sold_21',
  sold_30: 'sold_30',
  sold_45: 'sold_45',
  sold_60: 'sold_60',
  sold_90: 'sold_90',
  sold_120: 'sold_120',
  sold_180: 'sold_180',
  sold_365: 'sold_365',
  forecast_7: 'forecast_7',
  forecast_14: 'forecast_14',
  forecast_21: 'forecast_21',
  forecast_30: 'forecast_30',
  forecast_45: 'forecast_45',
  forecast_60: 'forecast_60',
  forecast_90: 'forecast_90',
  forecast_120: 'forecast_120',
  forecast_180: 'forecast_180',
  forecast_365: 'forecast_365'
} as const

export type product_metric_type = (typeof product_metric_type)[keyof typeof product_metric_type]


export const product_processing_spec_kind = {
  evaluation: 'evaluation',
  validation: 'validation'
} as const

export type product_processing_spec_kind = (typeof product_processing_spec_kind)[keyof typeof product_processing_spec_kind]


export const product_processing_spec_rule = {
  item_like_new: 'item_like_new',
  factory_sealed: 'factory_sealed',
  new_condition: 'new_condition',
  item_wear: 'item_wear',
  new_condition_after_cleaning: 'new_condition_after_cleaning',
  view: 'view',
  restock: 'restock',
  donate: 'donate',
  recycle: 'recycle',
  refurbish: 'refurbish',
  resell: 'resell'
} as const

export type product_processing_spec_rule = (typeof product_processing_spec_rule)[keyof typeof product_processing_spec_rule]


export const product_restriction_state = {
  allowed: 'allowed',
  restricted: 'restricted',
  unknown: 'unknown'
} as const

export type product_restriction_state = (typeof product_restriction_state)[keyof typeof product_restriction_state]


export const provider = {
  commentsold: 'commentsold',
  shopify: 'shopify',
  commerce_cloud: 'commerce_cloud',
  bigcommerce: 'bigcommerce',
  netsuite: 'netsuite',
  manual: 'manual',
  tiktok: 'tiktok',
  amazon: 'amazon',
  walmart: 'walmart',
  ebay: 'ebay',
  apparel_magic: 'apparel_magic',
  redo_marketplace: 'redo_marketplace',
  sfom: 'sfom',
  aims360: 'aims360',
  cin7_omni: 'cin7_omni',
  cin7_core: 'cin7_core',
  redo_api: 'redo_api',
  custom_return_integration: 'custom_return_integration',
  redo: 'redo',
  faire: 'faire',
  woocommerce: 'woocommerce',
  wayfair: 'wayfair',
  brightpearl: 'brightpearl',
  linnworks: 'linnworks',
  temu: 'temu',
  rithum: 'rithum'
} as const

export type provider = (typeof provider)[keyof typeof provider]


export const public_api_auth_scope = {
  orders_read: 'orders_read',
  orders_write: 'orders_write',
  customers_read: 'customers_read',
  customers_write: 'customers_write',
  products_read: 'products_read',
  products_write: 'products_write',
  returns_read: 'returns_read',
  returns_write: 'returns_write',
  webhooks_read: 'webhooks_read',
  webhooks_write: 'webhooks_write',
  inventory_read: 'inventory_read',
  inbound_shipments_read: 'inbound_shipments_read',
  invoices_read: 'invoices_read',
  customer_events_write: 'customer_events_write',
  storefront_events_write: 'storefront_events_write',
  locations_read: 'locations_read',
  locations_write: 'locations_write',
  shipping_read: 'shipping_read',
  shipping_write: 'shipping_write'
} as const

export type public_api_auth_scope = (typeof public_api_auth_scope)[keyof typeof public_api_auth_scope]


export const public_api_webhook_delivery_status = {
  pending: 'pending',
  succeeded: 'succeeded',
  failed: 'failed'
} as const

export type public_api_webhook_delivery_status = (typeof public_api_webhook_delivery_status)[keyof typeof public_api_webhook_delivery_status]


export const public_api_webhook_topic = {
  product_created: 'product_created',
  product_updated: 'product_updated',
  product_deleted: 'product_deleted',
  product_family_created: 'product_family_created',
  product_family_updated: 'product_family_updated',
  product_family_deleted: 'product_family_deleted',
  tracker_created: 'tracker_created',
  tracker_status_updated: 'tracker_status_updated',
  order_tracking_status_updated: 'order_tracking_status_updated',
  return_created: 'return_created',
  return_updated: 'return_updated'
} as const

export type public_api_webhook_topic = (typeof public_api_webhook_topic)[keyof typeof public_api_webhook_topic]


export const purchase_order_recommendation_status = {
  active: 'active',
  snoozed: 'snoozed',
  dismissed: 'dismissed',
  accepted: 'accepted',
  superseded: 'superseded',
  expired: 'expired'
} as const

export type purchase_order_recommendation_status = (typeof purchase_order_recommendation_status)[keyof typeof purchase_order_recommendation_status]


export const rate_source = {
  oxr: 'oxr',
  shopify: 'shopify',
  stripe: 'stripe'
} as const

export type rate_source = (typeof rate_source)[keyof typeof rate_source]


export const receiving_label_field = {
  returnId: 'returnId',
  orderName: 'orderName'
} as const

export type receiving_label_field = (typeof receiving_label_field)[keyof typeof receiving_label_field]


export const redo_cart_checkout_status = {
  active: 'active',
  completed: 'completed',
  expired: 'expired'
} as const

export type redo_cart_checkout_status = (typeof redo_cart_checkout_status)[keyof typeof redo_cart_checkout_status]


export const redo_cart_status = {
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED'
} as const

export type redo_cart_status = (typeof redo_cart_status)[keyof typeof redo_cart_status]


export const redo_shopify_country_code = {
  AC: 'AC',
  AD: 'AD',
  AE: 'AE',
  AF: 'AF',
  AG: 'AG',
  AI: 'AI',
  AL: 'AL',
  AM: 'AM',
  AN: 'AN',
  AO: 'AO',
  AR: 'AR',
  AS: 'AS',
  AT: 'AT',
  AU: 'AU',
  AW: 'AW',
  AX: 'AX',
  AZ: 'AZ',
  BA: 'BA',
  BB: 'BB',
  BD: 'BD',
  BE: 'BE',
  BF: 'BF',
  BG: 'BG',
  BH: 'BH',
  BI: 'BI',
  BJ: 'BJ',
  BL: 'BL',
  BM: 'BM',
  BN: 'BN',
  BO: 'BO',
  BQ: 'BQ',
  BR: 'BR',
  BS: 'BS',
  BT: 'BT',
  BV: 'BV',
  BW: 'BW',
  BY: 'BY',
  BZ: 'BZ',
  CA: 'CA',
  CC: 'CC',
  CD: 'CD',
  CF: 'CF',
  CG: 'CG',
  CH: 'CH',
  CI: 'CI',
  CK: 'CK',
  CL: 'CL',
  CM: 'CM',
  CN: 'CN',
  CO: 'CO',
  CR: 'CR',
  CU: 'CU',
  CV: 'CV',
  CW: 'CW',
  CX: 'CX',
  CY: 'CY',
  CZ: 'CZ',
  DE: 'DE',
  DJ: 'DJ',
  DK: 'DK',
  DM: 'DM',
  DO: 'DO',
  DZ: 'DZ',
  EC: 'EC',
  EE: 'EE',
  EG: 'EG',
  EH: 'EH',
  ER: 'ER',
  ES: 'ES',
  ET: 'ET',
  FI: 'FI',
  FJ: 'FJ',
  FK: 'FK',
  FO: 'FO',
  FR: 'FR',
  GA: 'GA',
  GB: 'GB',
  GD: 'GD',
  GE: 'GE',
  GF: 'GF',
  GG: 'GG',
  GH: 'GH',
  GI: 'GI',
  GL: 'GL',
  GM: 'GM',
  GN: 'GN',
  GP: 'GP',
  GQ: 'GQ',
  GR: 'GR',
  GS: 'GS',
  GT: 'GT',
  GU: 'GU',
  GW: 'GW',
  GY: 'GY',
  HK: 'HK',
  HM: 'HM',
  HN: 'HN',
  HR: 'HR',
  HT: 'HT',
  HU: 'HU',
  ID: 'ID',
  IE: 'IE',
  IL: 'IL',
  IM: 'IM',
  IN: 'IN',
  IO: 'IO',
  IQ: 'IQ',
  IR: 'IR',
  IS: 'IS',
  IT: 'IT',
  JE: 'JE',
  JM: 'JM',
  JO: 'JO',
  JP: 'JP',
  KE: 'KE',
  KG: 'KG',
  KH: 'KH',
  KI: 'KI',
  KM: 'KM',
  KN: 'KN',
  KP: 'KP',
  KR: 'KR',
  KW: 'KW',
  KY: 'KY',
  KZ: 'KZ',
  LA: 'LA',
  LB: 'LB',
  LC: 'LC',
  LI: 'LI',
  LK: 'LK',
  LR: 'LR',
  LS: 'LS',
  LT: 'LT',
  LU: 'LU',
  LV: 'LV',
  LY: 'LY',
  MA: 'MA',
  MC: 'MC',
  MD: 'MD',
  ME: 'ME',
  MF: 'MF',
  MG: 'MG',
  MK: 'MK',
  ML: 'ML',
  MM: 'MM',
  MN: 'MN',
  MO: 'MO',
  MQ: 'MQ',
  MR: 'MR',
  MS: 'MS',
  MT: 'MT',
  MU: 'MU',
  MV: 'MV',
  MW: 'MW',
  MX: 'MX',
  MY: 'MY',
  MZ: 'MZ',
  NA: 'NA',
  NC: 'NC',
  NE: 'NE',
  NF: 'NF',
  NG: 'NG',
  NI: 'NI',
  NL: 'NL',
  NO: 'NO',
  NP: 'NP',
  NR: 'NR',
  NU: 'NU',
  NZ: 'NZ',
  OM: 'OM',
  PA: 'PA',
  PE: 'PE',
  PF: 'PF',
  PG: 'PG',
  PH: 'PH',
  PK: 'PK',
  PL: 'PL',
  PM: 'PM',
  PN: 'PN',
  PR: 'PR',
  PS: 'PS',
  PT: 'PT',
  PY: 'PY',
  QA: 'QA',
  RE: 'RE',
  RO: 'RO',
  RS: 'RS',
  RU: 'RU',
  RW: 'RW',
  SA: 'SA',
  SB: 'SB',
  SC: 'SC',
  SD: 'SD',
  SE: 'SE',
  SG: 'SG',
  SH: 'SH',
  SI: 'SI',
  SJ: 'SJ',
  SK: 'SK',
  SL: 'SL',
  SM: 'SM',
  SN: 'SN',
  SO: 'SO',
  SR: 'SR',
  SS: 'SS',
  ST: 'ST',
  SV: 'SV',
  SX: 'SX',
  SY: 'SY',
  SZ: 'SZ',
  TA: 'TA',
  TC: 'TC',
  TD: 'TD',
  TF: 'TF',
  TG: 'TG',
  TH: 'TH',
  TJ: 'TJ',
  TK: 'TK',
  TL: 'TL',
  TM: 'TM',
  TN: 'TN',
  TO: 'TO',
  TR: 'TR',
  TT: 'TT',
  TV: 'TV',
  TW: 'TW',
  TZ: 'TZ',
  UA: 'UA',
  UG: 'UG',
  UM: 'UM',
  US: 'US',
  UY: 'UY',
  UZ: 'UZ',
  VA: 'VA',
  VC: 'VC',
  VE: 'VE',
  VG: 'VG',
  VI: 'VI',
  VN: 'VN',
  VU: 'VU',
  WF: 'WF',
  WS: 'WS',
  XK: 'XK',
  YE: 'YE',
  YT: 'YT',
  ZA: 'ZA',
  ZM: 'ZM',
  ZW: 'ZW',
  ZZ: 'ZZ'
} as const

export type redo_shopify_country_code = (typeof redo_shopify_country_code)[keyof typeof redo_shopify_country_code]


export const remit_mode = {
  AUTOMATIC: 'AUTOMATIC',
  manual: 'manual'
} as const

export type remit_mode = (typeof remit_mode)[keyof typeof remit_mode]


export const replenishment_request_status = {
  pending: 'pending',
  dismissed: 'dismissed',
  in_progress: 'in_progress',
  completed: 'completed',
  failed: 'failed'
} as const

export type replenishment_request_status = (typeof replenishment_request_status)[keyof typeof replenishment_request_status]


export const reserved_inventory_bucket_kind = {
  reserved: 'reserved',
  damaged: 'damaged',
  preorder: 'preorder',
  oversell: 'oversell'
} as const

export type reserved_inventory_bucket_kind = (typeof reserved_inventory_bucket_kind)[keyof typeof reserved_inventory_bucket_kind]


export const restriction_category = {
  cost: 'cost',
  dangerous_goods: 'dangerous_goods',
  documentation_required: 'documentation_required',
  information: 'information',
  permit_required: 'permit_required',
  product_compliance: 'product_compliance',
  prohibited: 'prohibited',
  quota: 'quota'
} as const

export type restriction_category = (typeof restriction_category)[keyof typeof restriction_category]


export const restriction_confidence = {
  high: 'high',
  medium: 'medium',
  low: 'low'
} as const

export type restriction_confidence = (typeof restriction_confidence)[keyof typeof restriction_confidence]


export const restriction_measure_direction = {
  import: 'import',
  export: 'export'
} as const

export type restriction_measure_direction = (typeof restriction_measure_direction)[keyof typeof restriction_measure_direction]


export const restriction_tier = {
  blocked: 'blocked',
  action_needed: 'action_needed',
  compliance_info: 'compliance_info',
  lane_notice: 'lane_notice'
} as const

export type restriction_tier = (typeof restriction_tier)[keyof typeof restriction_tier]


export const return_event_type = {
  warehouse_return_processed: 'warehouse_return_processed',
  return_delivered: 'return_delivered',
  warehouse_return_sorted: 'warehouse_return_sorted'
} as const

export type return_event_type = (typeof return_event_type)[keyof typeof return_event_type]


export const return_processing_flow_type = {
  compensation: 'compensation',
  restocking: 'restocking'
} as const

export type return_processing_flow_type = (typeof return_processing_flow_type)[keyof typeof return_processing_flow_type]


export const return_verification_lifecycle_stage = {
  return_point: 'return_point',
  warehouse: 'warehouse'
} as const

export type return_verification_lifecycle_stage = (typeof return_verification_lifecycle_stage)[keyof typeof return_verification_lifecycle_stage]


export const returns_processing_session_type = {
  verification: 'verification',
  grading: 'grading',
  license_plating: 'license_plating'
} as const

export type returns_processing_session_type = (typeof returns_processing_session_type)[keyof typeof returns_processing_session_type]


export const rfid_tag_type = {
  inventory_item: 'inventory_item',
  storage_location: 'storage_location',
  reference: 'reference'
} as const

export type rfid_tag_type = (typeof rfid_tag_type)[keyof typeof rfid_tag_type]


export const ringing_call_outcome = {
  answered: 'answered',
  timeout: 'timeout',
  rejected: 'rejected',
  busy: 'busy',
  offline: 'offline',
  cancelled: 'cancelled'
} as const

export type ringing_call_outcome = (typeof ringing_call_outcome)[keyof typeof ringing_call_outcome]


export const segment_membership_snapshot_reason = {
  monitor: 'monitor',
  condition_change: 'condition_change'
} as const

export type segment_membership_snapshot_reason = (typeof segment_membership_snapshot_reason)[keyof typeof segment_membership_snapshot_reason]


export const segment_membership_snapshot_status = {
  pending: 'pending',
  complete: 'complete'
} as const

export type segment_membership_snapshot_status = (typeof segment_membership_snapshot_status)[keyof typeof segment_membership_snapshot_status]


export const shipment_leg_kind = {
  first_mile: 'first_mile',
  last_mile: 'last_mile'
} as const

export type shipment_leg_kind = (typeof shipment_leg_kind)[keyof typeof shipment_leg_kind]


export const shipment_leg_status = {
  label_purchased: 'label_purchased',
  voided: 'voided'
} as const

export type shipment_leg_status = (typeof shipment_leg_status)[keyof typeof shipment_leg_status]


export const shipment_leg_tracking_status = {
  in_transit: 'in_transit',
  exception: 'exception',
  delivered: 'delivered'
} as const

export type shipment_leg_tracking_status = (typeof shipment_leg_tracking_status)[keyof typeof shipment_leg_tracking_status]


export const shipping_rate_table_type = {
  fixed: 'fixed',
  dynamic: 'dynamic',
  custom: 'custom'
} as const

export type shipping_rate_table_type = (typeof shipping_rate_table_type)[keyof typeof shipping_rate_table_type]


export const shopper_agent_channel_kind = {
  sms: 'sms',
  email: 'email',
  imessage: 'imessage'
} as const

export type shopper_agent_channel_kind = (typeof shopper_agent_channel_kind)[keyof typeof shopper_agent_channel_kind]


export const shopper_agent_config_status = {
  draft: 'draft',
  published: 'published',
  archived: 'archived'
} as const

export type shopper_agent_config_status = (typeof shopper_agent_config_status)[keyof typeof shopper_agent_config_status]


export const shopper_agent_discount_proclivity = {
  very_conservative: 'very_conservative',
  conservative: 'conservative',
  balanced: 'balanced',
  aggressive: 'aggressive',
  very_aggressive: 'very_aggressive'
} as const

export type shopper_agent_discount_proclivity = (typeof shopper_agent_discount_proclivity)[keyof typeof shopper_agent_discount_proclivity]


export const shopper_agent_outbound_message_kind = {
  outreach: 'outreach',
  reply: 'reply'
} as const

export type shopper_agent_outbound_message_kind = (typeof shopper_agent_outbound_message_kind)[keyof typeof shopper_agent_outbound_message_kind]


export const sort_disposition = {
  restock: 'restock',
  consolidation: 'consolidation',
  liquidation: 'liquidation',
  damaged: 'damaged',
  problem: 'problem',
  refurbishment: 'refurbishment'
} as const

export type sort_disposition = (typeof sort_disposition)[keyof typeof sort_disposition]


export const station_processing_session_close_reason = {
  manual: 'manual',
  daily_sweep: 'daily_sweep'
} as const

export type station_processing_session_close_reason = (typeof station_processing_session_close_reason)[keyof typeof station_processing_session_close_reason]


export const StorageLocationAdjustmentKind = {
  Manual: 'Manual',
  Pick: 'Pick',
  Putaway: 'Putaway',
  Receiving: 'Receiving',
  Transfer: 'Transfer',
  replenish: 'replenish',
  bin_count: 'bin_count',
  cycle_count: 'cycle_count',
  flush: 'flush'
} as const

export type StorageLocationAdjustmentKind = (typeof StorageLocationAdjustmentKind)[keyof typeof StorageLocationAdjustmentKind]


export const storage_location_priority = {
  primary: 'primary',
  secondary: 'secondary'
} as const

export type storage_location_priority = (typeof storage_location_priority)[keyof typeof storage_location_priority]


export const StorageLocationSource = {
  Manual: 'Manual',
  WarehouseMapper: 'WarehouseMapper',
  System: 'System'
} as const

export type StorageLocationSource = (typeof StorageLocationSource)[keyof typeof StorageLocationSource]


export const StorageLocationType = {
  Bin: 'Bin',
  Tote: 'Tote',
  Storage: 'Storage',
  Receiving: 'Receiving',
  External: 'External',
  lost: 'lost',
  Transit: 'Transit',
  unmapped: 'unmapped',
  default: 'default',
  waste: 'waste',
  flush: 'flush',
  Station: 'Station',
  SortingTote: 'SortingTote'
} as const

export type StorageLocationType = (typeof StorageLocationType)[keyof typeof StorageLocationType]


export const strike_lifecycle_event = {
  charge_created: 'charge_created',
  payout: 'payout'
} as const

export type strike_lifecycle_event = (typeof strike_lifecycle_event)[keyof typeof strike_lifecycle_event]


export const supplies_inventory_config_status = {
  active: 'active',
  paused: 'paused'
} as const

export type supplies_inventory_config_status = (typeof supplies_inventory_config_status)[keyof typeof supplies_inventory_config_status]


export const supplies_promotion_kind = {
  free_products: 'free_products'
} as const

export type supplies_promotion_kind = (typeof supplies_promotion_kind)[keyof typeof supplies_promotion_kind]


export const supplies_promotion_status = {
  draft: 'draft',
  active: 'active'
} as const

export type supplies_promotion_status = (typeof supplies_promotion_status)[keyof typeof supplies_promotion_status]


export const supplies_reorder_trigger_type = {
  initial_setup: 'initial_setup',
  inventory_threshold: 'inventory_threshold'
} as const

export type supplies_reorder_trigger_type = (typeof supplies_reorder_trigger_type)[keyof typeof supplies_reorder_trigger_type]


export const supplies_subscription_order_interval = {
  week: 'week',
  month: 'month'
} as const

export type supplies_subscription_order_interval = (typeof supplies_subscription_order_interval)[keyof typeof supplies_subscription_order_interval]


export const supplies_subscription_status = {
  active: 'active',
  paused: 'paused',
  canceled: 'canceled'
} as const

export type supplies_subscription_status = (typeof supplies_subscription_status)[keyof typeof supplies_subscription_status]


export const supplies_trackable_product_type = {
  label_paper: 'label_paper',
  parcel_packaging: 'parcel_packaging'
} as const

export type supplies_trackable_product_type = (typeof supplies_trackable_product_type)[keyof typeof supplies_trackable_product_type]


export const support_ticket_assignee_type = {
  USER: 'USER',
  AI: 'AI',
  CHAT_FLOW: 'CHAT_FLOW'
} as const

export type support_ticket_assignee_type = (typeof support_ticket_assignee_type)[keyof typeof support_ticket_assignee_type]


export const support_ticket_closure_reason = {
  EXPIRED: 'EXPIRED',
  RESOLVED: 'RESOLVED',
  MANUAL: 'MANUAL',
  SPAM: 'SPAM',
  DUPLICATE: 'DUPLICATE'
} as const

export type support_ticket_closure_reason = (typeof support_ticket_closure_reason)[keyof typeof support_ticket_closure_reason]


export const support_ticket_priority = {
  URGENT: 'URGENT'
} as const

export type support_ticket_priority = (typeof support_ticket_priority)[keyof typeof support_ticket_priority]


export const support_ticket_snooze_duration = {
  h_1: 'h_1',
  h_4: 'h_4',
  h_24: 'h_24'
} as const

export type support_ticket_snooze_duration = (typeof support_ticket_snooze_duration)[keyof typeof support_ticket_snooze_duration]


export const support_ticket_status = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  SNOOZED: 'SNOOZED',
  IN_PROGRESS: 'IN_PROGRESS',
  HIDDEN: 'HIDDEN',
  ARCHIVED: 'ARCHIVED',
  DELETED: 'DELETED',
  DRAFT: 'DRAFT'
} as const

export type support_ticket_status = (typeof support_ticket_status)[keyof typeof support_ticket_status]


export const surcharge_dispute_status = {
  open: 'open',
  submitted_to_carrier: 'submitted_to_carrier',
  accepted: 'accepted',
  rejected: 'rejected'
} as const

export type surcharge_dispute_status = (typeof surcharge_dispute_status)[keyof typeof surcharge_dispute_status]


export const tag_kind = {
  fulfillment_group: 'fulfillment_group',
  conversation: 'conversation',
  customer: 'customer',
  return: 'return',
  shipment: 'shipment'
} as const

export type tag_kind = (typeof tag_kind)[keyof typeof tag_kind]


export const task_assignee_type = {
  user: 'user',
  role: 'role'
} as const

export type task_assignee_type = (typeof task_assignee_type)[keyof typeof task_assignee_type]


export const task_assignment_status = {
  active: 'active',
  dismissed: 'dismissed',
  resolved: 'resolved'
} as const

export type task_assignment_status = (typeof task_assignment_status)[keyof typeof task_assignment_status]


export const task_domain = {
  warehouse: 'warehouse',
  returns: 'returns'
} as const

export type task_domain = (typeof task_domain)[keyof typeof task_domain]


export const task_priority = {
  low: 'low',
  medium: 'medium',
  high: 'high',
  urgent: 'urgent'
} as const

export type task_priority = (typeof task_priority)[keyof typeof task_priority]


export const task_status = {
  open: 'open',
  claimed: 'claimed',
  in_progress: 'in_progress',
  completed: 'completed',
  cancelled: 'cancelled'
} as const

export type task_status = (typeof task_status)[keyof typeof task_status]


export const task_subtype = {
  replenishment: 'replenishment',
  count: 'count',
  undeclared_item: 'undeclared_item',
  unfulfillable_item: 'unfulfillable_item'
} as const

export type task_subtype = (typeof task_subtype)[keyof typeof task_subtype]


export const task_user_event_type = {
  assignment_seen: 'assignment_seen',
  task_claimed: 'task_claimed',
  task_unclaimed: 'task_unclaimed',
  task_dismissed: 'task_dismissed'
} as const

export type task_user_event_type = (typeof task_user_event_type)[keyof typeof task_user_event_type]


export const team_calendar_entry_agenda_item_type = {
  promotion: 'promotion'
} as const

export type team_calendar_entry_agenda_item_type = (typeof team_calendar_entry_agenda_item_type)[keyof typeof team_calendar_entry_agenda_item_type]


export const team_calendar_entry_type = {
  marketing: 'marketing'
} as const

export type team_calendar_entry_type = (typeof team_calendar_entry_type)[keyof typeof team_calendar_entry_type]


export const time_based_integration_sync_severity = {
  medium: 'medium',
  high: 'high'
} as const

export type time_based_integration_sync_severity = (typeof time_based_integration_sync_severity)[keyof typeof time_based_integration_sync_severity]


export const time_based_integration_sync_type = {
  initial_backfill: 'initial_backfill',
  manual: 'manual',
  scheduled: 'scheduled'
} as const

export type time_based_integration_sync_type = (typeof time_based_integration_sync_type)[keyof typeof time_based_integration_sync_type]


export const timeline_actor_type = {
  SYSTEM: 'SYSTEM',
  RULE: 'RULE',
  USER: 'USER',
  CUSTOMER: 'CUSTOMER',
  AI: 'AI',
  EXTERNAL_USER: 'EXTERNAL_USER'
} as const

export type timeline_actor_type = (typeof timeline_actor_type)[keyof typeof timeline_actor_type]


export const topic_channel_thread_continuation_state = {
  continuation_enabled: 'continuation_enabled',
  context_only: 'context_only',
  detached: 'detached'
} as const

export type topic_channel_thread_continuation_state = (typeof topic_channel_thread_continuation_state)[keyof typeof topic_channel_thread_continuation_state]


export const topic_kind = {
  shopper_support: 'shopper_support',
  shopper_agent_conversation: 'shopper_agent_conversation',
  shopper_agent_outreach: 'shopper_agent_outreach'
} as const

export type topic_kind = (typeof topic_kind)[keyof typeof topic_kind]


export const topic_relationship_type = {
  merge: 'merge'
} as const

export type topic_relationship_type = (typeof topic_relationship_type)[keyof typeof topic_relationship_type]


export const transfer_order_kind = {
  shipment: 'shipment',
  simple: 'simple'
} as const

export type transfer_order_kind = (typeof transfer_order_kind)[keyof typeof transfer_order_kind]


export const transfer_order_status = {
  DRAFT: 'DRAFT',
  UNFULFILLED: 'UNFULFILLED',
  PARTIALLY_FULFILLED: 'PARTIALLY_FULFILLED',
  FULFILLED: 'FULFILLED',
  PARTIALLY_RECEIVED: 'PARTIALLY_RECEIVED',
  COMPLETE: 'COMPLETE'
} as const

export type transfer_order_status = (typeof transfer_order_status)[keyof typeof transfer_order_status]


export const transfer_side = {
  source: 'source',
  destination: 'destination'
} as const

export type transfer_side = (typeof transfer_side)[keyof typeof transfer_side]


export const transfer_type = {
  pick: 'pick',
  putaway: 'putaway',
  transfer: 'transfer',
  replenish: 'replenish',
  receiving: 'receiving',
  manual_pick: 'manual_pick',
  void: 'void',
  work_order: 'work_order',
  flush: 'flush'
} as const

export type transfer_type = (typeof transfer_type)[keyof typeof transfer_type]


export const undeclared_item_action = {
  dispose: 'dispose',
  send_back_to_customer: 'send_back_to_customer',
  process_according_to_service_agreement: 'process_according_to_service_agreement'
} as const

export type undeclared_item_action = (typeof undeclared_item_action)[keyof typeof undeclared_item_action]


export const voice_direction = {
  inbound: 'inbound',
  outbound: 'outbound'
} as const

export type voice_direction = (typeof voice_direction)[keyof typeof voice_direction]


export const voice_status = {
  ringing: 'ringing',
  answered: 'answered',
  missed: 'missed',
  voicemail: 'voicemail',
  completed: 'completed',
  failed: 'failed'
} as const

export type voice_status = (typeof voice_status)[keyof typeof voice_status]


export const voice_user_availability_status = {
  available: 'available',
  in_call: 'in_call',
  unavailable: 'unavailable'
} as const

export type voice_user_availability_status = (typeof voice_user_availability_status)[keyof typeof voice_user_availability_status]


export const withdrawal_status = {
  pending: 'pending',
  completed: 'completed',
  requires_merchant_action: 'requires_merchant_action',
  failed: 'failed'
} as const

export type withdrawal_status = (typeof withdrawal_status)[keyof typeof withdrawal_status]


export const work_order_pick_line_status = {
  pending: 'pending',
  committed: 'committed',
  picked: 'picked',
  short_picked: 'short_picked'
} as const

export type work_order_pick_line_status = (typeof work_order_pick_line_status)[keyof typeof work_order_pick_line_status]


export const work_order_status = {
  not_started: 'not_started',
  in_progress: 'in_progress',
  completed: 'completed',
  cancelled: 'cancelled',
  cancellation_pending: 'cancellation_pending',
  wasted: 'wasted',
  on_hold: 'on_hold'
} as const

export type work_order_status = (typeof work_order_status)[keyof typeof work_order_status]


export const work_order_triage_reason = {
  damaged: 'damaged',
  qa_fail: 'qa_fail',
  wrong_input: 'wrong_input',
  wrong_output: 'wrong_output',
  missing_materials: 'missing_materials',
  other: 'other'
} as const

export type work_order_triage_reason = (typeof work_order_triage_reason)[keyof typeof work_order_triage_reason]


export const work_order_triage_resolved_action = {
  back_to_picking: 'back_to_picking',
  back_to_start_of_step: 'back_to_start_of_step',
  skip_to_step: 'skip_to_step',
  cancel_batch: 'cancel_batch'
} as const

export type work_order_triage_resolved_action = (typeof work_order_triage_resolved_action)[keyof typeof work_order_triage_resolved_action]


export const work_order_trigger_kind = {
  order: 'order',
  replenishment: 'replenishment',
  manual: 'manual'
} as const

export type work_order_trigger_kind = (typeof work_order_trigger_kind)[keyof typeof work_order_trigger_kind]


export const work_order_waste_reason = {
  damaged: 'damaged',
  qa_fail: 'qa_fail',
  other: 'other'
} as const

export type work_order_waste_reason = (typeof work_order_waste_reason)[keyof typeof work_order_waste_reason]


export const ReturnsProcessingEventType = {
  session_started: 'session_started',
  session_completed: 'session_completed',
  session_timeout: 'session_timeout',
  session_abandoned: 'session_abandoned',
  session_item_started: 'session_item_started',
  session_item_completed: 'session_item_completed',
  session_item_timeout: 'session_item_timeout',
  processing_step_started: 'processing_step_started',
  processing_step_completed: 'processing_step_completed',
  evidence_added: 'evidence_added',
  agent_evaluation_completed: 'agent_evaluation_completed'
} as const

export type ReturnsProcessingEventType = (typeof ReturnsProcessingEventType)[keyof typeof ReturnsProcessingEventType]


export const ReclaimAccessMode = {
  trial: 'trial',
  free: 'free'
} as const

export type ReclaimAccessMode = (typeof ReclaimAccessMode)[keyof typeof ReclaimAccessMode]


export const DisputesAccessOverride = {
  default: 'default',
  trial: 'trial',
  free: 'free',
  paid: 'paid'
} as const

export type DisputesAccessOverride = (typeof DisputesAccessOverride)[keyof typeof DisputesAccessOverride]


export const ReclaimSourceRulePricingMode = {
  default: 'default',
  custom: 'custom'
} as const

export type ReclaimSourceRulePricingMode = (typeof ReclaimSourceRulePricingMode)[keyof typeof ReclaimSourceRulePricingMode]


export const CheckoutSessionStatus = {
  NotReadyForPayment: 'NotReadyForPayment',
  ReadyForPayment: 'ReadyForPayment',
  Completed: 'Completed',
  Cancelled: 'Cancelled'
} as const

export type CheckoutSessionStatus = (typeof CheckoutSessionStatus)[keyof typeof CheckoutSessionStatus]


export const FulfillmentGroupType = {
  Shipping: 'Shipping',
  Pickup: 'Pickup',
  Digital: 'Digital'
} as const

export type FulfillmentGroupType = (typeof FulfillmentGroupType)[keyof typeof FulfillmentGroupType]


export const PaymentInstrumentType = {
  Card: 'Card',
  BankAccount: 'BankAccount',
  PayPal: 'PayPal',
  Affirm: 'Affirm'
} as const

export type PaymentInstrumentType = (typeof PaymentInstrumentType)[keyof typeof PaymentInstrumentType]


export const GshopListingStatus = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  DISAPPROVED: 'DISAPPROVED',
  PENDING: 'PENDING'
} as const

export type GshopListingStatus = (typeof GshopListingStatus)[keyof typeof GshopListingStatus]


export const GshopProductFieldType = {
  title: 'title',
  description: 'description',
  brand: 'brand',
  google_product_category: 'google_product_category',
  product_type: 'product_type',
  link: 'link',
  custom_label_0: 'custom_label_0',
  custom_label_1: 'custom_label_1',
  custom_label_2: 'custom_label_2',
  custom_label_3: 'custom_label_3',
  custom_label_4: 'custom_label_4'
} as const

export type GshopProductFieldType = (typeof GshopProductFieldType)[keyof typeof GshopProductFieldType]


export const GshopVariantFieldType = {
  offer_id: 'offer_id',
  price: 'price',
  sale_price: 'sale_price',
  availability: 'availability',
  condition: 'condition',
  gtin: 'gtin',
  mpn: 'mpn',
  shipping_weight: 'shipping_weight',
  shipping_length: 'shipping_length',
  shipping_width: 'shipping_width',
  shipping_height: 'shipping_height',
  color: 'color',
  size: 'size',
  material: 'material',
  pattern: 'pattern',
  age_group: 'age_group',
  gender: 'gender'
} as const

export type GshopVariantFieldType = (typeof GshopVariantFieldType)[keyof typeof GshopVariantFieldType]


export const InventoryItemKind = {
  PRODUCT: 'PRODUCT',
  RETURN: 'RETURN',
  UNDECLARED: 'UNDECLARED',
  UNKNOWN: 'UNKNOWN'
} as const

export type InventoryItemKind = (typeof InventoryItemKind)[keyof typeof InventoryItemKind]


export const InventoryItemGrade = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E'
} as const

export type InventoryItemGrade = (typeof InventoryItemGrade)[keyof typeof InventoryItemGrade]


export const InventoryItemDisposition = {
  restock: 'restock',
  liquidate: 'liquidate',
  donate: 'donate',
  dispose: 'dispose',
  return_to_vendor: 'return_to_vendor'
} as const

export type InventoryItemDisposition = (typeof InventoryItemDisposition)[keyof typeof InventoryItemDisposition]


export const InventoryItemEventType = {
  restocked: 'restocked',
  picked: 'picked',
  shipped: 'shipped',
  committed: 'committed',
  released: 'released'
} as const

export type InventoryItemEventType = (typeof InventoryItemEventType)[keyof typeof InventoryItemEventType]


export const AttributeType = {
  short_text: 'short_text',
  list_short_text: 'list_short_text',
  long_text: 'long_text',
  rich_text: 'rich_text',
  json: 'json',
  date: 'date',
  datetime: 'datetime',
  integer: 'integer',
  float: 'float',
  boolean: 'boolean',
  enum: 'enum',
  product_category: 'product_category',
  hs_code: 'hs_code',
  weight: 'weight',
  money: 'money',
  dimension: 'dimension',
  volume: 'volume',
  link: 'link',
  color: 'color'
} as const

export type AttributeType = (typeof AttributeType)[keyof typeof AttributeType]


export const OwnerType = {
  product_family: 'product_family',
  product: 'product'
} as const

export type OwnerType = (typeof OwnerType)[keyof typeof OwnerType]


export const InventoryAdjustmentKind = {
  ReturnRestock: 'ReturnRestock',
  FulfillmentCreated: 'FulfillmentCreated',
  FulfillmentCancelled: 'FulfillmentCancelled',
  PurchaseOrderReceived: 'PurchaseOrderReceived',
  Manual: 'Manual',
  FulfillmentOrderCreated: 'FulfillmentOrderCreated',
  FulfillmentOrderCancelled: 'FulfillmentOrderCancelled',
  FulfillmentOrderEdited: 'FulfillmentOrderEdited',
  SotInitialization: 'SotInitialization',
  Unknown: 'Unknown',
  count: 'count',
  WmsTransfer: 'WmsTransfer',
  supplies: 'supplies'
} as const

export type InventoryAdjustmentKind = (typeof InventoryAdjustmentKind)[keyof typeof InventoryAdjustmentKind]


export const ProductSource = {
  Shopify: 'Shopify',
  BigCommerce: 'BigCommerce',
  CommentSold: 'CommentSold',
  CommerceCloud: 'CommerceCloud',
  Cin7Omni: 'Cin7Omni',
  Cin7Core: 'Cin7Core',
  Amazon: 'Amazon',
  ebay: 'ebay'
} as const

export type ProductSource = (typeof ProductSource)[keyof typeof ProductSource]


export const WeightUnit = {
  Gram: 'Gram',
  Kilogram: 'Kilogram',
  Ounce: 'Ounce',
  Pound: 'Pound',
  Tonne: 'Tonne'
} as const

export type WeightUnit = (typeof WeightUnit)[keyof typeof WeightUnit]


export const AdjustmentSessionKind = {
  Receive: 'Receive',
  Count: 'Count',
  Transfer: 'Transfer'
} as const

export type AdjustmentSessionKind = (typeof AdjustmentSessionKind)[keyof typeof AdjustmentSessionKind]


export const ExternalProductIdentifierType = {
  LPN: 'LPN'
} as const

export type ExternalProductIdentifierType = (typeof ExternalProductIdentifierType)[keyof typeof ExternalProductIdentifierType]


export const PurchaseOrderStatus = {
  DRAFT: 'DRAFT',
  SUPPLIER_CONTACTED: 'SUPPLIER_CONTACTED',
  ORDERED: 'ORDERED',
  PARTIALLY_RECEIVED: 'PARTIALLY_RECEIVED',
  CLOSED: 'CLOSED',
  CANCELLED: 'CANCELLED'
} as const

export type PurchaseOrderStatus = (typeof PurchaseOrderStatus)[keyof typeof PurchaseOrderStatus]


export const ShopifyProductFieldType = {
  category_id: 'category_id',
  title: 'title',
  description: 'description',
  vendor: 'vendor',
  product_type: 'product_type',
  handle: 'handle',
  seo_title: 'seo_title',
  seo_description: 'seo_description',
  metafield: 'metafield'
} as const

export type ShopifyProductFieldType = (typeof ShopifyProductFieldType)[keyof typeof ShopifyProductFieldType]


export const ShopifyVariantFieldType = {
  sku: 'sku',
  requires_shipping: 'requires_shipping',
  country_of_origin: 'country_of_origin',
  hs_code: 'hs_code',
  weight: 'weight',
  barcode: 'barcode',
  price: 'price',
  cost: 'cost',
  compare_at_price: 'compare_at_price',
  display_name: 'display_name',
  title: 'title',
  taxable: 'taxable',
  inventory_policy: 'inventory_policy',
  show_unit_price: 'show_unit_price',
  upm_measured_type: 'upm_measured_type',
  upm_quantity_unit: 'upm_quantity_unit',
  upm_quantity_value: 'upm_quantity_value',
  upm_reference_unit: 'upm_reference_unit',
  upm_reference_value: 'upm_reference_value',
  metafield: 'metafield',
  inventory_tracked: 'inventory_tracked'
} as const

export type ShopifyVariantFieldType = (typeof ShopifyVariantFieldType)[keyof typeof ShopifyVariantFieldType]


export const AmazonFulfillmentChannel = {
  AFN: 'AFN',
  MFN: 'MFN'
} as const

export type AmazonFulfillmentChannel = (typeof AmazonFulfillmentChannel)[keyof typeof AmazonFulfillmentChannel]


export const AmazonListingStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  INCOMPLETE: 'INCOMPLETE'
} as const

export type AmazonListingStatus = (typeof AmazonListingStatus)[keyof typeof AmazonListingStatus]


export const MarketplaceCartStatus = {
  active: 'active',
  pending: 'pending',
  submitted: 'submitted',
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
  SUBMITTED: 'SUBMITTED'
} as const

export type MarketplaceCartStatus = (typeof MarketplaceCartStatus)[keyof typeof MarketplaceCartStatus]


export const EbayListingStatus = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  ARCHIVED: 'ARCHIVED'
} as const

export type EbayListingStatus = (typeof EbayListingStatus)[keyof typeof EbayListingStatus]


export const EbayProductFieldType = {
  title: 'title',
  description: 'description',
  condition: 'condition',
  price: 'price',
  brand: 'brand',
  category: 'category',
  aspect: 'aspect'
} as const

export type EbayProductFieldType = (typeof EbayProductFieldType)[keyof typeof EbayProductFieldType]


export const EbayVariantFieldType = {
  sku: 'sku',
  price: 'price',
  aspect: 'aspect'
} as const

export type EbayVariantFieldType = (typeof EbayVariantFieldType)[keyof typeof EbayVariantFieldType]


export const ListingDurationEnum = {
  GTC: 'GTC',
  DAYS_1: 'DAYS_1',
  DAYS_3: 'DAYS_3',
  DAYS_5: 'DAYS_5',
  DAYS_7: 'DAYS_7',
  DAYS_10: 'DAYS_10',
  DAYS_21: 'DAYS_21',
  DAYS_30: 'DAYS_30'
} as const

export type ListingDurationEnum = (typeof ListingDurationEnum)[keyof typeof ListingDurationEnum]


export const FormatEnum = {
  FIXED_PRICE: 'FIXED_PRICE',
  AUCTION: 'AUCTION'
} as const

export type FormatEnum = (typeof FormatEnum)[keyof typeof FormatEnum]


export const ConditionEnum = {
  NEW: 'NEW',
  USED: 'USED',
  REFURBISHED: 'REFURBISHED'
} as const

export type ConditionEnum = (typeof ConditionEnum)[keyof typeof ConditionEnum]


export const PoshmarkVariantTypeEnum = {
  PARENT: 'PARENT',
  CHILD: 'CHILD'
} as const

export type PoshmarkVariantTypeEnum = (typeof PoshmarkVariantTypeEnum)[keyof typeof PoshmarkVariantTypeEnum]


export const PoshmarkConditionEnum = {
  NWT: 'NWT'
} as const

export type PoshmarkConditionEnum = (typeof PoshmarkConditionEnum)[keyof typeof PoshmarkConditionEnum]


export const PoshmarkAvailabilityEnum = {
  FOR_SALE: 'FOR_SALE',
  NOT_FOR_SALE: 'NOT_FOR_SALE',
  DRAFT: 'DRAFT',
  DROPS: 'DROPS'
} as const

export type PoshmarkAvailabilityEnum = (typeof PoshmarkAvailabilityEnum)[keyof typeof PoshmarkAvailabilityEnum]


export const SyncSourceEnum = {
  SHOPIFY: 'SHOPIFY',
  POSHMARK: 'POSHMARK',
  EBAY: 'EBAY'
} as const

export type SyncSourceEnum = (typeof SyncSourceEnum)[keyof typeof SyncSourceEnum]


export const PoshmarkProductFieldType = {
  title: 'title',
  description: 'description',
  department: 'department',
  category: 'category',
  brand: 'brand',
  condition: 'condition',
  color1: 'color1',
  color2: 'color2',
  style_tags: 'style_tags'
} as const

export type PoshmarkProductFieldType = (typeof PoshmarkProductFieldType)[keyof typeof PoshmarkProductFieldType]


export const PoshmarkVariantFieldType = {
  sku: 'sku',
  size: 'size',
  upc: 'upc',
  original_price: 'original_price',
  listing_price: 'listing_price',
  availability: 'availability',
  variant_group_id: 'variant_group_id',
  variant_type: 'variant_type',
  variant_attribute: 'variant_attribute'
} as const

export type PoshmarkVariantFieldType = (typeof PoshmarkVariantFieldType)[keyof typeof PoshmarkVariantFieldType]


export const VendorAccessLevel = {
  CAMPAIGN: 'CAMPAIGN',
  MARKETPLACE: 'MARKETPLACE'
} as const

export type VendorAccessLevel = (typeof VendorAccessLevel)[keyof typeof VendorAccessLevel]


export const RedoMarketplaceProductFieldType = {
  title: 'title',
  description: 'description',
  vendor: 'vendor',
  price: 'price'
} as const

export type RedoMarketplaceProductFieldType = (typeof RedoMarketplaceProductFieldType)[keyof typeof RedoMarketplaceProductFieldType]


export const RedoMarketplaceVariantFieldType = {
  sku: 'sku',
  price: 'price',
  title: 'title',
  compare_at_price: 'compare_at_price'
} as const

export type RedoMarketplaceVariantFieldType = (typeof RedoMarketplaceVariantFieldType)[keyof typeof RedoMarketplaceVariantFieldType]


export const SellerAgreementStatus = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  EXPIRED: 'EXPIRED',
  TERMINATED: 'TERMINATED'
} as const

export type SellerAgreementStatus = (typeof SellerAgreementStatus)[keyof typeof SellerAgreementStatus]


export const SellerAgreementChannel = {
  REDO: 'REDO',
  EBAY: 'EBAY',
  POSHMARK: 'POSHMARK'
} as const

export type SellerAgreementChannel = (typeof SellerAgreementChannel)[keyof typeof SellerAgreementChannel]


export const CatalogSource = {
  Shopify: 'Shopify',
  Ebay: 'Ebay',
  Poshmark: 'Poshmark'
} as const

export type CatalogSource = (typeof CatalogSource)[keyof typeof CatalogSource]


export const ShopifyListingStatus = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  ARCHIVED: 'ARCHIVED',
  UNLISTED: 'UNLISTED'
} as const

export type ShopifyListingStatus = (typeof ShopifyListingStatus)[keyof typeof ShopifyListingStatus]


export const ShopifyMediaType = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  EXTERNAL_VIDEO: 'EXTERNAL_VIDEO',
  MODEL_3D: 'MODEL_3D'
} as const

export type ShopifyMediaType = (typeof ShopifyMediaType)[keyof typeof ShopifyMediaType]


export const return_label_provider = {
  wegrow: 'wegrow'
} as const

export type return_label_provider = (typeof return_label_provider)[keyof typeof return_label_provider]


export const ReturnIntegrationProvider = {
  aims360: 'aims360',
  apparelmagic: 'apparelmagic',
  blueyonder: 'blueyonder',
  brightpearl: 'brightpearl',
  cloudx: 'cloudx',
  flexport: 'flexport',
  inmar: 'inmar',
  netsuite: 'netsuite',
  returnbear: 'returnbear',
  sfom: 'sfom',
  shipbob: 'shipbob',
  shiphero: 'shiphero',
  trackstar: 'trackstar'
} as const

export type ReturnIntegrationProvider = (typeof ReturnIntegrationProvider)[keyof typeof ReturnIntegrationProvider]


export const ReturnVerificationResult = {
  pending: 'pending',
  pass: 'pass',
  fail: 'fail'
} as const

export type ReturnVerificationResult = (typeof ReturnVerificationResult)[keyof typeof ReturnVerificationResult]


export const ReturnVerificationItemKind = {
  declared: 'declared',
  undeclared: 'undeclared',
  unknown: 'unknown'
} as const

export type ReturnVerificationItemKind = (typeof ReturnVerificationItemKind)[keyof typeof ReturnVerificationItemKind]


export const ReturnVerificationItemResult = {
  pending: 'pending',
  item_like_new: 'item_like_new',
  item_damaged: 'item_damaged',
  item_not_received: 'item_not_received'
} as const

export type ReturnVerificationItemResult = (typeof ReturnVerificationItemResult)[keyof typeof ReturnVerificationItemResult]


export const ReturnsProcessingItemStatus = {
  pending: 'pending',
  received: 'received',
  missing: 'missing',
  processed: 'processed'
} as const

export type ReturnsProcessingItemStatus = (typeof ReturnsProcessingItemStatus)[keyof typeof ReturnsProcessingItemStatus]


export const support_ticket_customer_sentiment = {
  POSITIVE: 'POSITIVE',
  NEUTRAL: 'NEUTRAL',
  NEGATIVE: 'NEGATIVE'
} as const

export type support_ticket_customer_sentiment = (typeof support_ticket_customer_sentiment)[keyof typeof support_ticket_customer_sentiment]


export const support_ticket_assignee_summary = {
  AI_AGENT_HANDLED: 'AI_AGENT_HANDLED',
  MERCHANT_HANDLED: 'MERCHANT_HANDLED',
  AI_AGENT_HANDOFF_TO_HUMAN: 'AI_AGENT_HANDOFF_TO_HUMAN',
  AI_AGENT_HANDOFF_TO_IGNORED: 'AI_AGENT_HANDOFF_TO_IGNORED',
  MERCHANT_IGNORED: 'MERCHANT_IGNORED'
} as const

export type support_ticket_assignee_summary = (typeof support_ticket_assignee_summary)[keyof typeof support_ticket_assignee_summary]


export const conversation_billing_type = {
  AI_BUCKETED: 'AI_BUCKETED',
  BASE_BUCKETED: 'BASE_BUCKETED',
  AI_FIXED: 'AI_FIXED',
  BASE_FIXED: 'BASE_FIXED'
} as const

export type conversation_billing_type = (typeof conversation_billing_type)[keyof typeof conversation_billing_type]


export const message_channel = {
  gmail: 'gmail',
  outlook: 'outlook',
  customEmail: 'customEmail',
  redoChat: 'redoChat',
  facebookDm: 'facebookDm',
  facebookComments: 'facebookComments',
  instagramDm: 'instagramDm',
  instagramComments: 'instagramComments',
  sms: 'sms',
  mobileMessage: 'mobileMessage',
  voice: 'voice',
  attentive: 'attentive',
  postscript: 'postscript',
  tiktok: 'tiktok',
  contactForm: 'contactForm',
  internalNote: 'internalNote'
} as const

export type message_channel = (typeof message_channel)[keyof typeof message_channel]


export const message_origin = {
  external: 'external',
  internal: 'internal'
} as const

export type message_origin = (typeof message_origin)[keyof typeof message_origin]


export const message_email_address_type = {
  from: 'from',
  to: 'to',
  cc: 'cc',
  bcc: 'bcc',
  replyTo: 'replyTo'
} as const

export type message_email_address_type = (typeof message_email_address_type)[keyof typeof message_email_address_type]


export const message_instagram_comment_state = {
  normal: 'normal',
  deleted: 'deleted',
  hidden: 'hidden',
  edited: 'edited'
} as const

export type message_instagram_comment_state = (typeof message_instagram_comment_state)[keyof typeof message_instagram_comment_state]


export const message_redo_chat_confirmation_state = {
  pending: 'pending',
  confirmed: 'confirmed',
  rejected: 'rejected'
} as const

export type message_redo_chat_confirmation_state = (typeof message_redo_chat_confirmation_state)[keyof typeof message_redo_chat_confirmation_state]


export const message_sms_service = {
  SMS: 'SMS',
  MMS: 'MMS',
  RCS: 'RCS',
  iMessage: 'iMessage'
} as const

export type message_sms_service = (typeof message_sms_service)[keyof typeof message_sms_service]


export const shopper_ai_integration_type = {
  gmail: 'gmail',
  outlook: 'outlook',
  instagram: 'instagram',
  facebook: 'facebook',
  tiktok: 'tiktok',
  attentive: 'attentive',
  postscript: 'postscript',
  redoChatAi: 'redoChatAi',
  redoChatFlow: 'redoChatFlow',
  redoChatLive: 'redoChatLive',
  telnyx_sms: 'telnyx_sms',
  telnyx_voice: 'telnyx_voice',
  mobileMessage: 'mobileMessage',
  contactForm: 'contactForm',
  sms_phone_number: 'sms_phone_number',
  imessage: 'imessage',
  custom_email: 'custom_email',
  gorgias_sms: 'gorgias_sms',
  shared_sms: 'shared_sms'
} as const

export type shopper_ai_integration_type = (typeof shopper_ai_integration_type)[keyof typeof shopper_ai_integration_type]


export const channel_thread_analytics_handoff_source = {
  tool_call: 'tool_call',
  handoff_detection: 'handoff_detection'
} as const

export type channel_thread_analytics_handoff_source = (typeof channel_thread_analytics_handoff_source)[keyof typeof channel_thread_analytics_handoff_source]


export const message_instagram_comment_attribute = {
  has_been_replied_to: 'has_been_replied_to',
  liked: 'liked'
} as const

export type message_instagram_comment_attribute = (typeof message_instagram_comment_attribute)[keyof typeof message_instagram_comment_attribute]


export const message_meta_comment_attribute = {
  has_been_replied_to: 'has_been_replied_to',
  liked: 'liked'
} as const

export type message_meta_comment_attribute = (typeof message_meta_comment_attribute)[keyof typeof message_meta_comment_attribute]


export const message_meta_comment_state = {
  normal: 'normal',
  deleted: 'deleted',
  hidden: 'hidden',
  edited: 'edited'
} as const

export type message_meta_comment_state = (typeof message_meta_comment_state)[keyof typeof message_meta_comment_state]


export const message_meta_comment_type = {
  facebook: 'facebook',
  instagram: 'instagram'
} as const

export type message_meta_comment_type = (typeof message_meta_comment_type)[keyof typeof message_meta_comment_type]


export const thread_product_analytics_type = {
  PDP_INTERACTION: 'PDP_INTERACTION',
  SUGGESTED_PRODUCT: 'SUGGESTED_PRODUCT',
  ADDED_TO_CART: 'ADDED_TO_CART',
  BACK_IN_STOCK_SUBSCRIPTION: 'BACK_IN_STOCK_SUBSCRIPTION'
} as const

export type thread_product_analytics_type = (typeof thread_product_analytics_type)[keyof typeof thread_product_analytics_type]


export const time_based_integration_sync_direction = {
  forward: 'forward',
  backward: 'backward'
} as const

export type time_based_integration_sync_direction = (typeof time_based_integration_sync_direction)[keyof typeof time_based_integration_sync_direction]
